import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from "react";

var _iconsLActivitySvg = function _iconsLActivitySvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M2 10h3l3-7 4 14 3-7h3",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLActivitySvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLAddSvg = function _iconsLAddSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10 4v12m6-6H4",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLAddSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLAppSwitcherSvg = function _iconsLAppSwitcherSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3 1h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1v18m9-9H1",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLAppSwitcherSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLAreaSvg = function _iconsLAreaSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1 3h13",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2v2m13-2v2m3 3h2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 18V7",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 18h2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "1",
    y: "7",
    width: "13",
    height: "11",
    rx: "1",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLAreaSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLArrowDownCircleSvg = function _iconsLArrowDownCircleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1 10v0a9 9 0 0 1 9-9v0a9 9 0 0 1 9 9v0a9 9 0 0 1-9 9v0a9 9 0 0 1-9-9z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14V6m3 5-3 3-3-3",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLArrowDownCircleSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLArrowLeftCircleSvg = function _iconsLArrowLeftCircleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10 1v0a9 9 0 0 1 9 9v0a9 9 0 0 1-9 9v0a9 9 0 0 1-9-9v0a9 9 0 0 1 9-9z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10h8m-5 3-3-3 3-3",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLArrowLeftCircleSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLArrowRightCircleSvg = function _iconsLArrowRightCircleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10 19v0a9 9 0 0 1-9-9v0a9 9 0 0 1 9-9v0a9 9 0 0 1 9 9v0a9 9 0 0 1-9 9z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10H6m5-3 3 3-3 3",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLArrowRightCircleSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLArrowUpCircleSvg = function _iconsLArrowUpCircleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M19 10v0a9 9 0 0 1-9 9v0a9 9 0 0 1-9-9v0a9 9 0 0 1 9-9v0a9 9 0 0 1 9 9z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6v8M7 9l3-3 3 3",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLArrowUpCircleSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLBathSvg = function _iconsLBathSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12.527 7H9.474a1 1 0 0 1-.95-1.316A2.462 2.462 0 0 1 10.862 4h.278c1.06 0 2 .678 2.336 1.684A1 1 0 0 1 12.527 7zm-7.534 4H2c-.614 0-1.083.57-.988 1.199l.344 2.286C1.66 16.509 3.337 18 5.308 18h9.384c1.97 0 3.648-1.491 3.952-3.514l.344-2.286c.095-.63-.374-1.199-.988-1.199h-7.737",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 4a3 3 0 1 1 6 0v7M4.04 17.8 3 19m14 0-1.04-1.2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLBathSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLBedSvg = function _iconsLBedSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M17.2 10H2.8A1.8 1.8 0 0 0 1 11.8v3.3a.9.9 0 0 0 .9.9h16.2c.497 0 .9-1.063.9-1.56V11.8a1.8 1.8 0 0 0-1.8-1.8z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8 9.5V5.7A2.7 2.7 0 0 1 5.5 3h9a2.7 2.7 0 0 1 2.7 2.7v3.8M18 16v2M2 16v2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9.7v0A2.7 2.7 0 0 1 8.7 7h2.7a2.7 2.7 0 0 1 2.7 2.7v0",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLBedSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLBellSvg = function _iconsLBellSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3.994 11V7c0-3.314 2.689-6 6.006-6a6.003 6.003 0 0 1 6.006 6v4c0 .986.448 1.919 1.217 2.537l.309.248c.917.736.396 2.215-.78 2.215H3.248c-1.176 0-1.697-1.479-.78-2.215l.309-.248A3.252 3.252 0 0 0 3.994 11z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 19h3",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLBellSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLBuildingsSvg = function _iconsLBuildingsSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.999 18.996v-17a1 1 0 0 1 1-1h6.003a1 1 0 0 1 1 1v17m3.998 0V5.91a.913.913 0 0 0-.914-.913h-3.084m-8.004-.001H2.913A.913.913 0 0 0 2 5.91v13.087m7-10h2m-2 3.999h2m-2-8h2m-1 12v2.001m9-.001H1",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLBuildingsSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLCalendarSvg = function _iconsLCalendarSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5 2v2m10-2v2M1 8h18.008M1 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V6z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLCalendarSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLCarSvg = function _iconsLCarSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m19 7-2.291.87M3.3 7.87 1 7m15 5h-2m-8 0H4m13.5-4-1.296-4.012C15.974 2.83 15.004 2 13.88 2H6.212c-1.101 0-2.059.8-2.31 1.931L2.5 8",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.125 18H4.15c.745 0 1.35-.672 1.35-1.5V16h9v.5c0 .828.605 1.5 1.35 1.5h2.025c.621 0 1.125-.56 1.125-1.25V11c0-1.657-1.209-3-2.7-3H3.7C2.209 8 1 9.343 1 11v5.75c0 .69.504 1.25 1.125 1.25z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLCarSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLChartBarSvg = function _iconsLChartBarSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M2 19h16",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 19V7h3.143c.473 0 .857.448.857 1v11h-4zm-4 0V2c0-.552.384-1 .857-1h2.286c.473 0 .857.448.857 1v17H8zm-4 0V5c0-.552.384-1 .857-1H8v15H4z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLChartBarSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLCheckCircleSvg = function _iconsLCheckCircleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "9",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.442 10.34 2.168 2.167-.014-.014 4.891-4.89",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLCheckCircleSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLCheckSvg = function _iconsLCheckSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m15.5 6-7 8-4-4",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLCheckSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLChevronDownSvg = function _iconsLChevronDownSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m6 9 4 4 4-4",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLChevronDownSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLChevronLeftSvg = function _iconsLChevronLeftSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m11 6-4 4 4 4",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLChevronLeftSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLChevronRightSvg = function _iconsLChevronRightSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m9 14 4-4-4-4",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLChevronRightSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLChevronUpSvg = function _iconsLChevronUpSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m14 11-4-4-4 4",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLChevronUpSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLClockBackSvg = function _iconsLClockBackSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.5 10 10V6",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.636 3.636A9 9 0 1 1 1 10",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 2v3h3",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLClockBackSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLClockSvg = function _iconsLClockSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "9.004",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 12-3-1V6",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLClockSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLCollapseSvg = function _iconsLCollapseSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M18 6h-4V2m5-1-5 5M2 14h4v4m-5 1 5-5M2 9V4a2 2 0 0 1 2-2h5m9 9v5a2 2 0 0 1-2 2h-6",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLCollapseSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLColumnsSvg = function _iconsLColumnsSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3 1h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 1v18m6-18v18",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLColumnsSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLComputerSvg = function _iconsLComputerSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M17 15H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 15 .5 4M8 15l-.5 4m-2.3 0h9.6m4.2-8H1",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLComputerSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLCrossLargeSvg = function _iconsLCrossLargeSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m3 3 14 14m0-14L3 17",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLCrossLargeSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLCrossSmallSvg = function _iconsLCrossSmallSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m6.667 6.667 6.666 6.666m0-6.666-6.667 6.666",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLCrossSmallSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLDashboardSvg = function _iconsLDashboardSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "9.995",
    cy: "10.008",
    r: "1.999",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.994 6.01-2.499 2.498m4.795 1.5h-.9m-11.7 0h.9M9.991 3.71v.9m-4.455.944.45.45",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M9.714 1.005a9.099 9.099 0 0 0-8.718 8.98 8.978 8.978 0 0 0 3.739 7.318c.666.465 1.462.71 2.275.7h5.978a3.813 3.813 0 0 0 2.226-.677 8.994 8.994 0 0 0-5.5-16.321z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLDashboardSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLDeleteCrossSvg = function _iconsLDeleteCrossSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M3 5h14m-1 0v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5m9-3H7m5 11L8 9m0 4 4-4",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLDeleteCrossSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLDocumentLegalSvg = function _iconsLDocumentLegalSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1.996 2.997a2 2 0 0 1 2-2h12.006a2 2 0 0 1 2 2v3.001M3.998 19.004a2 2 0 0 1-2-2.001l.003-11V3A2 2 0 0 1 4 1h12.006a2 2 0 0 1 2 2v14.007a2 2 0 0 1-2 2L6 19l-2.003.004z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.999 15.002v0a1.5 1.5 0 0 1-1.5-1.5v0A1.5 1.5 0 0 1 6.998 12v0a1.5 1.5 0 0 1 1.5 1.5v0A1.5 1.5 0 0 1 7 15.002z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.498 4.998 14.5 5m-9 4h6m.5 5h2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLDocumentLegalSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLDownloadSvg = function _iconsLDownloadSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10 15V1m8 18H2m13-9-5.001 5.001-5-5.001",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLDownloadSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLDragHandleSvg = function _iconsLDragHandleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "7.5",
    cy: "2.5",
    r: "1.5",
    transform: "rotate(-180 7.5 2.5)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "2.5",
    r: "1.5",
    transform: "rotate(-180 12.5 2.5)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "7.5",
    cy: "7.5",
    r: "1.5",
    transform: "rotate(-180 7.5 7.5)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "7.5",
    r: "1.5",
    transform: "rotate(-180 12.5 7.5)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "7.5",
    cy: "12.5",
    r: "1.5",
    transform: "rotate(-180 7.5 12.5)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "7.5",
    cy: "17.5",
    r: "1.5",
    transform: "rotate(-180 7.5 17.5)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "1.5",
    transform: "rotate(-180 12.5 12.5)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "17.5",
    r: "1.5",
    transform: "rotate(-180 12.5 17.5)",
    fill: "currentColor"
  }));
};

_iconsLDragHandleSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLEditSvg = function _iconsLEditSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3.293 13.619 13.619 3.293a1 1 0 0 1 1.413 0l1.676 1.676a1 1 0 0 1 0 1.413L6.381 16.707a.995.995 0 0 1-.706.293H3v-2.675c0-.265.105-.519.293-.706z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.75 5.16 3.09 3.09",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLEditSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLEllipsisSvg = function _iconsLEllipsisSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M18 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLEllipsisSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLEnvelopeSvg = function _iconsLEnvelopeSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.636 3.045h14.727c.904 0 1.637.733 1.637 1.637v10.636c0 .904-.733 1.636-1.636 1.636H2.636A1.635 1.635 0 0 1 1 15.318V4.682c0-.904.733-1.637 1.636-1.637z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.12 4.075 7.693 5.503a2 2 0 0 0 2.325.002l7.738-5.519",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLEnvelopeSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLExpandSvg = function _iconsLExpandSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15 1h4v4m-5 1 5-5M5 19H1v-4m5-1-5 5M2 9V4a2 2 0 0 1 2-2h5m9 9v5a2 2 0 0 1-2 2h-6",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLExpandSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLExperimentSvg = function _iconsLExperimentSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14 1H6m6.39 1v5.845l4.128 6.429c.611.952.643 2.15.084 3.132A3.2 3.2 0 0 1 13.822 19H6.19a3.201 3.201 0 0 1-2.79-1.59 3.013 3.013 0 0 1 .081-3.136l4.128-6.43V2",
    stroke: "currentColor",
    strokeWidth: "1.966",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 9H7",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLExperimentSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLEyeClosedSvg = function _iconsLEyeClosedSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10 17c-.842 0-1.685-.178-2.504-.495m11.386-6.037C16.99 13.967 13.495 17 10 17m7.08-10.079a15.135 15.135 0 0 1 1.802 2.612.987.987 0 0 1 0 .935M3 17 17 3m-9.227 9.227a3.15 3.15 0 0 1 4.455-4.455",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.044 4.956C13.497 3.759 11.748 3 10 3 6.505 3 3.01 6.033 1.118 9.533a.987.987 0 0 0 0 .935c.946 1.749 2.292 3.381 3.838 4.577",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLEyeClosedSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLEyeOpenSvg = function _iconsLEyeOpenSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1.118 10.467a.987.987 0 0 1 0-.935C3.01 6.033 6.505 3 10 3s6.99 3.033 8.882 6.533a.987.987 0 0 1 0 .935C16.99 13.967 13.495 17 10 17s-6.99-3.033-8.882-6.533z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.121 7.879A3 3 0 1 1 7.88 12.12a3 3 0 0 1 4.24-4.24",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLEyeOpenSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLFileSvg = function _iconsLFileSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6 11h8m-8 4h8",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4 1h9.172a2 2 0 0 1 1.414.586l2.828 2.828A2 2 0 0 1 18 5.828V17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 6h-4a1 1 0 0 1-1-1V1M6 7h3",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLFileSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLFilterSvg = function _iconsLFilterSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m13 12 4.707-5.707A1 1 0 0 0 18 5.586V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v2.586c0 .265.105.52.293.707L8 12m0 0v5.832c0 .76.764 1.316 1.553 1.133l2.5-.584c.556-.13.947-.596.947-1.132V12",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLFilterSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLFolderArchiveSvg = function _iconsLFolderArchiveSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("rect", {
    x: "1",
    y: "9",
    width: "18",
    height: "10",
    rx: "2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.999 13.001h4.002M17 9V4.163c0-.764-.697-1.383-1.556-1.383h-5.033c-.258 0-.498-.163-.643-.352L8.675 1.302A.808.808 0 0 0 8.033 1H4.556c-.413 0-.809.145-1.1.405A1.31 1.31 0 0 0 3 2.383V9",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLFolderArchiveSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLHamburgerSvg = function _iconsLHamburgerSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M3 10h14M3 15.002h14M3 4.998 17 5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLHamburgerSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLHeartFilledSvg = function _iconsLHeartFilledSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.696 2C16.871 2 19 4.98 19 7.755 19 13.388 10.161 18 10 18c-.161 0-9-4.612-9-10.245C1 4.98 3.129 2 6.304 2 8.119 2 9.311 3.194 10 4c.689-.806 1.881-2 3.696-2z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLHeartFilledSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLHeartOutlineSvg = function _iconsLHeartOutlineSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13.696 2C16.871 2 19 4.98 19 7.755 19 13.388 10.161 18 10 18c-.161 0-9-4.612-9-10.245C1 4.98 3.129 2 6.304 2 8.119 2 9.311 3.194 10 4c.689-.806 1.881-2 3.696-2z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLHeartOutlineSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLHouseSearchSvg = function _iconsLHouseSearchSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M18 8V2.059C18 1.474 17.535 1 16.963 1h-1.926C14.465 1 14 1.474 14 2.059V4.5M1 9l7.698-6.524a2.017 2.017 0 0 1 2.603 0L19 9",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 8.5v8.503a2 2 0 0 0 2 2h5m10.004.001L17 17m-2.5-6a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLHouseSearchSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLHouseSvg = function _iconsLHouseSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M.996 8.696 8.934 1.89a1.637 1.637 0 0 1 2.131 0l7.939 6.805",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.003 18.004V1.497a.5.5 0 0 0-.5-.5h-3.001a.5.5 0 0 0-.5.5v2.607M8 18v-5.077c0-.51.365-.923.815-.923h2.37c.45 0 .815.413.815.923V18M2 8v10m17.004.004H.996",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLHouseSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLInfoCircleSvg = function _iconsLInfoCircleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10 19v0a9 9 0 0 1-9-9v0a9 9 0 0 1 9-9v0a9 9 0 0 1 9 9v0a9 9 0 0 1-9 9z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15v-5H9m.749-4a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLInfoCircleSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLInvoiceSvg = function _iconsLInvoiceSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15.867 19H4.133C2.955 19 2 18.105 2 17V3c0-1.105.955-2 2.133-2h11.734C17.045 1 18 1.895 18 3v14c0 1.105-.955 2-2.133 2z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 5h1m-1 3h1m-1 3h1m-8 4h8M8 5.042v-1m0 7v1m-1.736-1.715c.259.424.701.717 1.236.717h1.096a1.404 1.404 0 0 0 .341-2.766l-1.874-.47a1.405 1.405 0 0 1 .341-2.767H8.5c.533 0 .975.293 1.233.715",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLInvoiceSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLKebabSvg = function _iconsLKebabSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10 18a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-7a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-7a1 1 0 1 1 0-2 1 1 0 0 1 0 2z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLKebabSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLKeysSvg = function _iconsLKeysSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m9.723 5.363.433-.433a3.001 3.001 0 0 1 4.245 0l4.515 4.515a3.716 3.716 0 0 1 0 5.256l-.222.221a3.716 3.716 0 0 1-5.256 0l-3.514-3.514",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12.514c-1.478-.738-2.504-2.25-2.504-4.015A4.502 4.502 0 0 1 11 8.5c0 1.764-1.025 3.276-2.501 4.014v-.002l-.001 4.496a.997.997 0 0 1-.293.703l-1.003 1.003a.997.997 0 0 1-1.41-.001L4.79 17.706a.998.998 0 0 1-.292-.705l.002-4.489",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8.5 6 3.747C6 2.227 7.48 1 9 1s3 1.228 3 2.747v.318",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.497 8.25a.25.25 0 1 0 .004.5.25.25 0 0 0-.004-.5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLKeysSvg.defaultProps = {
  width: "22",
  height: "21",
  viewBox: "0 0 22 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLLeaseAgreementSvg = function _iconsLLeaseAgreementSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M16 6V3a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M5.5 15v0A1.5 1.5 0 0 1 4 13.5v0A1.5 1.5 0 0 1 5.5 12v0A1.5 1.5 0 0 1 7 13.5v0A1.5 1.5 0 0 1 5.5 15z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5h8M4 8.5h4",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m12.164 14.652-1.906 1.91a.89.89 0 0 0-.258.624v.935c0 .488.395.883.883.883h.939a.88.88 0 0 0 .624-.26l1.902-1.906a3.515 3.515 0 1 0-2.184-2.186v0z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.431 13.532a.04.04 0 1 0 0 .08.04.04 0 0 0 0-.08v0",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLLeaseAgreementSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLLoaderSvg = function _iconsLLoaderSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10 1a9 9 0 1 0 9 9",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.505 2.204v.001s0 0 0 0 0 0 0 0 0 0 0 0M17.8 5.5s0 0 0 0v.001s0 0 0 0V5.5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLLoaderSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLLocationMarkerSvg = function _iconsLLocationMarkerSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10 11v0a3 3 0 0 1-3-3v0a3 3 0 0 1 3-3v0a3 3 0 0 1 3 3v0a3 3 0 0 1-3 3z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10 19S3 13.25 3 8a7 7 0 1 1 14 0c0 5.25-7 11-7 11z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLLocationMarkerSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLLockClosedSvg = function _iconsLLockClosedSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15 19H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 7V5a4 4 0 0 0-4-4v0a4 4 0 0 0-4 4v2m3.998 5.5a.5.5 0 1 0 .004 1 .5.5 0 0 0-.004-1",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLLockClosedSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLLockOpenSvg = function _iconsLLockOpenSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15 19H5a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 5a4 4 0 0 0-4-4 3.992 3.992 0 0 0-3.866 3.023M14 8V5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLLockOpenSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLMessagesQuestionSvg = function _iconsLMessagesQuestionSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1 9.213c0 2.693 1.42 5.064 3.599 6.559-.001.858.001 2.014.001 3.228l3.531-1.754c.604.117 1.228.18 1.869.18 4.952 0 9-3.657 9-8.213C19 4.657 14.952 1 10 1S1 4.657 1 9.213z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9 10.275v-.208c0-.682.418-1.052.838-1.335.41-.278.821-.64.821-1.308 0-.923-.743-1.67-1.659-1.67s-1.66.746-1.66 1.67m1.658 5.204a.149.149 0 0 0-.15.151.15.15 0 1 0 .3 0 .15.15 0 0 0-.15-.15",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLMessagesQuestionSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLMobileSvg = function _iconsLMobileSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.499.996v1.801a.557.557 0 0 0 .5.6h4.002a.557.557 0 0 0 .5-.6v-1.8M7.999 16.003h4.002",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14.002 19.004H5.998a2 2 0 0 1-2-2.001V2.997a2 2 0 0 1 2-2h8.004a2 2 0 0 1 2 2v14.006a2 2 0 0 1-2 2z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLMobileSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLNoteSvg = function _iconsLNoteSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4 18h9.172a2.14 2.14 0 0 0 1.414-.52l2.828-2.515c.375-.333.586-.785.586-1.257v-9.93C18 2.796 17.105 2 16 2H4c-1.105 0-2 .796-2 1.778v12.444C2 17.204 2.895 18 4 18z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13h-4a1 1 0 0 0-1 1v4",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLNoteSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLOpenSvg = function _iconsLOpenSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14 1h5v5m-7 2 7-7m-1 10.563v5.312C18 18.049 17.05 19 15.875 19H3.125A2.124 2.124 0 0 1 1 16.875V4.125C1 2.951 1.95 2 3.125 2h5.313",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLOpenSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLPaperClipSvg = function _iconsLPaperClipSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 15V7a2.008 2.008 0 0 0-2-2.008v0A2.009 2.009 0 0 0 7.983 7v7M5 6v9.05M15 6v7m-3 2v.5A3.5 3.5 0 0 1 8.5 19v0A3.5 3.5 0 0 1 5 15.5V15",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6v0a5 5 0 0 0-5-5v0a5 5 0 0 0-5 5v0",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLPaperClipSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLPeopleSvg = function _iconsLPeopleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1 17v-.401C1 14.619 2.5 13 4.333 13h3.334C9.5 13 11 14.62 11 16.599V17m2.5-5h2.8c1.53 0 2.7 1.269 2.7 2.799V15",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "7",
    r: "3",
    stroke: "currentColor",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "7",
    r: "2",
    stroke: "currentColor",
    strokeWidth: "2"
  }));
};

_iconsLPeopleSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLPersonSvg = function _iconsLPersonSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M3 17c0-2.273 2.014-4 4.432-4h5.136C15.086 13 17 14.818 17 17M12.802 3.138c1.597 1.612 1.597 4.171 0 5.688-1.598 1.517-4.135 1.612-5.639 0-1.503-1.611-1.597-4.171 0-5.688a4.062 4.062 0 0 1 5.639 0",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLPersonSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLPinSvg = function _iconsLPinSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10 19v-6",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12.897 8h-5.8a3 3 0 0 0-2.914 2.289l-.133.546A1.75 1.75 0 0 0 5.75 13h8.5a1.75 1.75 0 0 0 1.7-2.165l-.133-.546A3 3 0 0 0 12.897 8v0z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.999 8 12.1 4.6a1 1 0 0 1 .386-.965L13.6 2.8A1 1 0 0 0 13 1H7a1 1 0 0 0-.6 1.8l1.114.835A1 1 0 0 1 7.9 4.6L7.001 8",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLPinSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLPlaceholderSvg = function _iconsLPlaceholderSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "9",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeDasharray: "2 4"
  }));
};

_iconsLPlaceholderSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLPrinterSvg = function _iconsLPrinterSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5 6V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v4M5 15H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M5 12h10v6.028c0 .536-.448.972-1 .972H6c-.552 0-1-.436-1-.972V12z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9h1",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLPrinterSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLReceiptSvg = function _iconsLReceiptSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14 5H6m8.13 4H6",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2 17.889V2.056C2 1.473 2.448 1 3 1h14c.552 0 1 .473 1 1.056v15.833c0 .393-.5 1.111-1 1.111l-2-1-2 .945c-.141.073-.859.073-1 0L10 18l-2 .945c-.141.073-.859.073-1 0L5 18l-2 1c-.5 0-1-.718-1-1.111z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 13H6",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLReceiptSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLRulerSvg = function _iconsLRulerSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m5.855 10.146 4 4a.5.5 0 0 1-.354.853h-4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .854-.353z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m4.415 1.586 13.999 14A2 2 0 0 1 16.999 19H3a2 2 0 0 1-2-2V3a2 2 0 0 1 3.415-1.414z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.416 14.587-1.413 1.412m-3-3 1.412-1.413M7.001 6.997l1.413-1.412m1.588 4.413 1.412-1.412M4 4.023l1.426-1.426",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLRulerSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLSearchSvg = function _iconsLSearchSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14.244 4.101A7.172 7.172 0 1 1 4.101 14.245 7.172 7.172 0 0 1 14.244 4.1M18 18l-3.76-3.76",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLSearchSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLSettingsGearSvg = function _iconsLSettingsGearSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.7 10H19M1 10h1.575m6.076 2.336L5.5 17.794m9-15.588-.788 1.364M8.651 7.664 5.5 2.206m9 15.588-.788-1.364M15.25 4.75a7.424 7.424 0 1 1-10.5 10.5 7.424 7.424 0 0 1 10.5-10.5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "2.7",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.206 14.5 1.364-.788M17.794 5.5l-1.364.788M10 19v-1.575M10 1v1.575M17.794 14.5l-1.364-.788M2.206 5.5l1.364.788",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLSettingsGearSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLSettingsSvg = function _iconsLSettingsSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M17.121 9.121A3 3 0 1 1 12.88 4.88a3 3 0 0 1 4.24 4.24M15 4V2m0 16v-8m-7.879 4.121A3 3 0 1 1 2.88 9.88a3 3 0 0 1 4.24 4.24M5 2v7m0 7v2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLSettingsSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLSolSvg = function _iconsLSolSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.828 7.172a4 4 0 1 1-5.656 5.656 4 4 0 0 1 5.656-5.656M10 3V1m0 18v-2m5-12 1-1M4 16l1-1m12-5h2M1 10h2m12 5 1 1M4 4l1 1",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLSolSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLSortSvg = function _iconsLSortSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 6 5 3 2 6m3 11V3m7 11 3 3 3-3M15 3v14",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLSortSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLSpannerSvg = function _iconsLSpannerSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13.006 1.07c1.296.635 2.563 1.664 3.21 2.932 1.664 3.144.603 7.01-2.448 8.918-3.05 1.908-7.085 1.229-9.308-1.566a6.798 6.798 0 0 1-.69-7.352c.648-1.27 1.92-2.298 3.219-2.931a.715.715 0 0 1 .683.034c.207.127.33.35.328.588V7h4V1.693a.682.682 0 0 1 .326-.584.715.715 0 0 1 .68-.038z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 13v6h8v-6",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLSpannerSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLUnpinSvg = function _iconsLUnpinSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m5.386 15.554 3.536-3.536",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.775 18.735-7.778-7.778",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14.506 10.531 10.405 6.43a3 3 0 0 0-3.68-.442l-.48.292a1.75 1.75 0 0 0-.328 2.733l6.01 6.01a1.75 1.75 0 0 0 2.733-.328l.292-.48a3 3 0 0 0-.446-3.684v0z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.578 10.603 1.769-3.04a1 1 0 0 1 .955-.41l1.378.198a1 1 0 0 0 .848-1.697l-4.242-4.242a1 1 0 0 0-1.697.848l.197 1.378a1 1 0 0 1-.41.955l-3.04 1.77",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLUnpinSvg.defaultProps = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsLWarningCircleSvg = function _iconsLWarningCircleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10 1v0a9 9 0 0 1 9 9v0a9 9 0 0 1-9 9v0a9 9 0 0 1-9-9v0a9 9 0 0 1 9-9z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11V6m.006 8a.006.006 0 1 0 0 .012.006.006 0 0 0 .006-.006.006.006 0 0 0-.006-.006",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsLWarningCircleSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMActivitySvg = function _iconsMActivitySvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M2 8h2l2-5 3 10 3-5h2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMActivitySvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMAddSubractSvg = function _iconsMAddSubractSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15 13h-4M5 3H1m12 0L3 13m0-8V1",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMAddSubractSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMAddSvg = function _iconsMAddSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 3v10m5-5H3",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMAddSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMAppSwitcherSvg = function _iconsMAppSwitcherSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.556 1h10.888C14.304 1 15 1.696 15 2.556v10.888c0 .86-.696 1.556-1.556 1.556H2.556C1.696 15 1 14.304 1 13.444V2.556C1 1.696 1.696 1 2.556 1z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1v14m7-7H1",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMAppSwitcherSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMAreaSvg = function _iconsMAreaSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1 2h9",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1v2m9-2v2m3 3h2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15V6",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 15h2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "1",
    y: "6",
    width: "9",
    height: "9",
    rx: ".8",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMAreaSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMArrowBackSvg = function _iconsMArrowBackSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5 1 2 4l3 3",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 4h6c3.314 0 6 1.962 6 5 0 3.038-2.686 5-6 5H3",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMArrowBackSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMArrowDownCircleSvg = function _iconsMArrowDownCircleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1 8v0a7 7 0 0 1 7-7v0a7 7 0 0 1 7 7v0a7 7 0 0 1-7 7v0a7 7 0 0 1-7-7z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11V5m2.5 3.5L8 11 5.5 8.5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMArrowDownCircleSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMArrowDownFilledSvg = function _iconsMArrowDownFilledSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m4 6 4 4 4-4",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 6 4 4 4-4H4z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMArrowDownFilledSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMArrowDownOutlineSvg = function _iconsMArrowDownOutlineSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 6H4l4 4 4-4z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinejoin: "round"
  }));
};

_iconsMArrowDownOutlineSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMArrowLeftCircleSvg = function _iconsMArrowLeftCircleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8 1v0a7 7 0 0 1 7 7v0a7 7 0 0 1-7 7v0a7 7 0 0 1-7-7v0a7 7 0 0 1 7-7z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8h6m-3.5 2.5L5 8l2.5-2.5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMArrowLeftCircleSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMArrowLeftFilledSvg = function _iconsMArrowLeftFilledSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4 5 8l4 4",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4 5 8l4 4V4z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMArrowLeftFilledSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMArrowRightCircleSvg = function _iconsMArrowRightCircleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8 15v0a7 7 0 0 1-7-7v0a7 7 0 0 1 7-7v0a7 7 0 0 1 7 7v0a7 7 0 0 1-7 7z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 8H5m3.5-2.5L11 8l-2.5 2.5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMArrowRightCircleSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMArrowUpCircleSvg = function _iconsMArrowUpCircleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15 8v0a7 7 0 0 1-7 7v0a7 7 0 0 1-7-7v0a7 7 0 0 1 7-7v0a7 7 0 0 1 7 7z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5v6M5.5 7.5 8 5l2.5 2.5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMArrowUpCircleSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMBathSvg = function _iconsMBathSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M9.208 6H6.792c-.54 0-.922-.669-.75-1.316C6.305 3.678 7.051 3 7.89 3h.22c.839 0 1.584.678 1.849 1.684.17.647-.21 1.316-.75 1.316zM4.106 9H1.778c-.478 0-.842.407-.768.856l.267 1.633C1.514 12.935 2.817 14 4.351 14h7.298c1.533 0 2.838-1.065 3.074-2.51l.268-1.633c.073-.45-.291-.856-.769-.856H8.205",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 9V3.4C13 2.074 11.88 1 10.5 1c-1.137 0-2.097.729-2.4 1.727M3 14l-1 1m12 0-1-1",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMBathSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMBedSvg = function _iconsMBedSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13.6 8H2.4C1.627 8 1 8.671 1 9.5v2.75c0 .414.314.75.7.75h12.6c.386 0 .7-.886.7-1.3V9.5c0-.829-.627-1.5-1.4-1.5z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 8V4.492C2 3.116 3.007 2 4.25 2h7.5C12.993 2 14 3.116 14 4.492V8m0 5v2M2 13v2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8v0c0-1.657 1.194-3 2.667-3h2.666C10.806 5 12 6.343 12 8v0",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMBedSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMBellSvg = function _iconsMBellSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3.495 8.333V5.4C3.495 2.97 5.512 1 8 1s4.505 1.97 4.505 4.4v2.933c0 .723.335 1.408.912 1.86l.232.183c.688.54.297 1.624-.585 1.624H2.936c-.882 0-1.273-1.085-.585-1.624l.232-.182a2.366 2.366 0 0 0 .912-1.86z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 15h2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMBellSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMBuildingsSvg = function _iconsMBuildingsSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5 14V2.667C5 2.298 5.336 2 5.75 2h4.5c.414 0 .75.298.75.667V14m4 0V5.587c0-.324-.327-.587-.73-.587H12M5 5H1.811C1.363 5 1 5.263 1 5.587V14m7-9h-.01M8 8h-.01M8 11h-.01M15 14H1",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMBuildingsSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMCalendarSvg = function _iconsMCalendarSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5 2v2m6-2v2M1 7h14M1 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMCalendarSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMCarSvg = function _iconsMCarSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m15 6-1.5 1m-11 0L1 6m11 4h-1m-6 0H4m10-4-1.037-3.343C12.779 1.692 12.003 1 11.104 1H4.97c-.881 0-1.648.667-1.848 1.61L2 6",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1.875 15H3.45c.58 0 1.05-.938 1.05-1.6V13h7v.4c0 .662.47 1.6 1.05 1.6h1.575c.483 0 .875-.448.875-1V9.4c0-1.326-.94-2.4-2.1-2.4H3.1C1.94 7 1 8.074 1 9.4V14c0 .552.392 1 .875 1z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMCarSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMChartBarSvg = function _iconsMChartBarSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1 15h14",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10 15V6h3.143c.473 0 .857.336.857.75V15h-4zm-4 0V1.778c0-.43.384-.778.857-.778h2.286c.473 0 .857.348.857.778V15H6zm-4 0V3.8c0-.442.384-.8.857-.8H6v12H2z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMChartBarSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMCheckCircleSvg = function _iconsMCheckCircleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "7",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 8 1 1 1 1 4-4",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMCheckCircleSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMCheckSvg = function _iconsMCheckSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5 7 11 4 8",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMCheckSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMChevronDownSvg = function _iconsMChevronDownSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m4 6 4 4 4-4",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMChevronDownSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMChevronLeftSvg = function _iconsMChevronLeftSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9 4 5 8l4 4",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMChevronLeftSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMChevronRightSvg = function _iconsMChevronRightSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m7 4 4 4-4 4",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMChevronRightSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMChevronUpSvg = function _iconsMChevronUpSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 10 8 6l-4 4",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMChevronUpSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMCircleFilledSvg = function _iconsMCircleFilledSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0z",
    fill: "currentColor"
  }));
};

_iconsMCircleFilledSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMCircleOutlineSvg = function _iconsMCircleOutlineSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0z",
    stroke: "currentColor",
    strokeWidth: "2"
  }));
};

_iconsMCircleOutlineSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMClockBackSvg = function _iconsMClockBackSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M3.05 3.05A7 7 0 1 1 1 8",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 9-2-.833V5M2 2v2h2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMClockBackSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMClockSvg = function _iconsMClockSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "7",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 9-2-.833V5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMClockSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMCollapseSvg = function _iconsMCollapseSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m15 1-4 4m3 0h-3V2m-9 9h3v3m-4 1 4-4M2 7V3.429C2 2.639 2.64 2 3.429 2H7m7 7v3.571c0 .79-.56 1.429-1.25 1.429H9",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMCollapseSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMColumnsSvg = function _iconsMColumnsSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.556 1h10.888C14.304 1 15 1.696 15 2.556v10.888c0 .86-.696 1.556-1.556 1.556H2.556C1.696 15 1 14.304 1 13.444V2.556C1 1.696 1.696 1 2.556 1z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 2v13",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMColumnsSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMCommentSvg = function _iconsMCommentSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m5 15 4-3m-4 0v3m0-3c-2.147 0-4-1.76-4-3.929V4.93C1 2.759 2.741 1 4.889 1h6.222C13.26 1 15 2.76 15 4.929V8.07c0 2.171-1.741 3.93-3.889 3.93H9",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMCommentSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMComputerSvg = function _iconsMComputerSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13.444 11H2.556C1.696 11 1 10.36 1 9.571V2.43C1 1.639 1.696 1 2.556 1h10.888C14.304 1 15 1.64 15 2.429V9.57c0 .79-.696 1.429-1.556 1.429z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.5 11 .5 4m-3.5-4L6 15m-2 0h8m3-7H1",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMComputerSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMCrossLargeSvg = function _iconsMCrossLargeSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m2 2 12 12m0-12L2 14",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMCrossLargeSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMCrossSmallSvg = function _iconsMCrossSmallSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m4.5 4.5 7 7m0-7-7 7",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMCrossSmallSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMDashSvg = function _iconsMDashSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13 8H3",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMDashSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMDashboardSvg = function _iconsMDashboardSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9 6 8 9m5.95-1h-.9m-11 0h.9M8 2.05v.9m-4.45.6.9.9m8-.9-.9.9",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7.78 1.004C4.022 1.158 1.045 4.174 1 7.869a6.829 6.829 0 0 0 2.907 5.595 3.057 3.057 0 0 0 1.77.536h4.648a3.002 3.002 0 0 0 1.731-.518c2.516-1.757 3.563-4.927 2.577-7.802-.985-2.874-3.77-4.775-6.854-4.676z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "9",
    r: "1",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMDashboardSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMDeleteCrossSvg = function _iconsMDeleteCrossSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M2 4h12m-1 0v9.308A1.68 1.68 0 0 1 11.333 15H4.667A1.68 1.68 0 0 1 3 13.308V4m7-3H6m3.6 10.2L6.4 8m0 3.2L9.6 8",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMDeleteCrossSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMDocumentLegalSvg = function _iconsMDocumentLegalSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M2 2.555C2 1.696 2.671 1 3.5 1h8.998c.828 0 1.5.696 1.5 1.555v2.333M3.5 14.998c-.829 0-1.5-.697-1.5-1.556l.003-8.551V2.558c0-.859.671-1.555 1.5-1.555H12.5c.829 0 1.5.696 1.5 1.555v10.887c0 .859-.671 1.555-1.5 1.555L5 14.994l-1.5.003zM5 4h6M5 7h5m0 4h1",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6 12v0a1 1 0 0 1-1-1v0a1 1 0 0 1 1-1v0a1 1 0 0 1 1 1v0a1 1 0 0 1-1 1z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMDocumentLegalSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMDownloadSvg = function _iconsMDownloadSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 10V1m6 14H2m10-8-4 4-4-4",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMDownloadSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMDragHandleSvg = function _iconsMDragHandleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "2",
    r: "1",
    transform: "rotate(-180 6 2)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "6",
    r: "1",
    transform: "rotate(-180 6 6)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "10",
    r: "1",
    transform: "rotate(-180 6 10)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "14",
    r: "1",
    transform: "rotate(-180 6 14)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "2",
    r: "1",
    transform: "rotate(-180 10 2)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "6",
    r: "1",
    transform: "rotate(-180 10 6)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "1",
    transform: "rotate(-180 10 10)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "14",
    r: "1",
    transform: "rotate(-180 10 14)",
    fill: "currentColor"
  }));
};

_iconsMDragHandleSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMEditSvg = function _iconsMEditSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1.293 11.619 11.619 1.293a1 1 0 0 1 1.413 0l1.676 1.676a1 1 0 0 1 0 1.413L4.381 14.707a.995.995 0 0 1-.706.293H1v-2.675c0-.265.105-.519.293-.706z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.75 3.16 3.09 3.09",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMEditSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMEllipsisSvg = function _iconsMEllipsisSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14.75 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-6 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-6 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMEllipsisSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMEnvelopeSvg = function _iconsMEnvelopeSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.272 2.59h11.455c.703 0 1.273.57 1.273 1.274v8.272c0 .703-.57 1.273-1.272 1.273H2.272c-.702 0-1.272-.57-1.272-1.273V3.864c0-.703.57-1.273 1.272-1.273z",
    stroke: "currentColor",
    strokeWidth: "1.944",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.5 4 5.566 3.633a1.577 1.577 0 0 0 1.833.001L14.5 4",
    stroke: "currentColor",
    strokeWidth: "1.971",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMEnvelopeSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMExpandSvg = function _iconsMExpandSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 1h3v3m-4 1 4-4M4 15H1v-3m4-1-4 4m1-8V3.429C2 2.639 2.64 2 3.429 2H7m7 7v3.571c0 .79-.56 1.429-1.25 1.429H9",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMExpandSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMExperimentSvg = function _iconsMExperimentSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11 1H5m5.048 1v4.47L13.5 11c.524.728.638 2.03.159 2.781-.48.75-1.392 1.217-2.383 1.219H4.734c-.992.001-1.907-.464-2.39-1.215-.481-.751-.368-2.056.157-2.785l3.452-4.53V2",
    stroke: "currentColor",
    strokeWidth: "1.966",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7H6",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMExperimentSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMEyeClosedSvg = function _iconsMEyeClosedSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 13.067c-.334 0-.668-.04-1-.112m7.387-4.585c-1.36 2.516-3.874 4.697-6.387 4.697m6.387-4.697a.71.71 0 0 0 0-.672 10.545 10.545 0 0 0-.759-1.198M2.966 13.067 13.033 3M9.5 6.366A2.266 2.266 0 0 0 6.366 9.5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.627 4.407C10.514 3.546 9.257 3 8 3 5.487 3 2.973 5.181 1.613 7.698a.71.71 0 0 0 0 .672c.68 1.258 1.648 2.431 2.76 3.291",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMEyeClosedSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMEyeOpenSvg = function _iconsMEyeOpenSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1.614 8.334a.705.705 0 0 1 0-.668C2.966 5.166 5.462 3 7.958 3c2.497 0 4.993 2.166 6.345 4.666a.705.705 0 0 1 0 .668C12.95 10.834 10.455 13 7.958 13c-2.496 0-4.992-2.166-6.344-4.666z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.474 6.485a2.143 2.143 0 1 1-3.031 3.03 2.143 2.143 0 0 1 3.03-3.03",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMEyeOpenSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMFileSvg = function _iconsMFileSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5 8h6m-6 3h6",
    stroke: "currentColor",
    strokeWidth: "1.944",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3.5 1h6.879c.398 0 .78.164 1.06.456l2.121 2.2c.282.291.44.687.44 1.1v8.688c0 .86-.671 1.556-1.5 1.556h-9c-.829 0-1.5-.696-1.5-1.556V2.556C2 1.696 2.671 1 3.5 1z",
    stroke: "currentColor",
    strokeWidth: "1.944",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 5h-3.2a.8.8 0 0 1-.8-.8V1M5 5h2",
    stroke: "currentColor",
    strokeWidth: "1.944",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMFileSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMFilterSvg = function _iconsMFilterSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m10 10 3.838-4.764a.753.753 0 0 0 .22-.533v-1.95A.754.754 0 0 0 13.306 2H2.754A.754.754 0 0 0 2 2.754v1.949c0 .2.08.392.22.533L6 10m0 0v4.166c0 .542.611.94 1.242.809l2-.417c.445-.093.758-.426.758-.809V10",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMFilterSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMFolderArchiveSvg = function _iconsMFolderArchiveSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("rect", {
    x: "1",
    y: "8",
    width: "14",
    height: "7",
    rx: "1.6",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 11h4m4-3V4.21C14 3.54 13.402 3 12.666 3H8.352c-.22 0-.427-.143-.55-.308l-.938-1.428A.687.687 0 0 0 6.314 1h-2.98c-.354 0-.693.127-.944.354-.25.227-.39.535-.39.856V8",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMFolderArchiveSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMHamburgerSvg = function _iconsMHamburgerSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M2 8h12M2 12.001h12M2 4h12",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMHamburgerSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMHeartFilledSvg = function _iconsMHeartFilledSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.875 2C13.345 2 15 4.235 15 6.316 15 10.541 8.125 14 8 14s-7-3.459-7-7.684C1 4.235 2.656 2 5.125 2 6.537 2 7.465 2.896 8 3.5 8.536 2.896 9.463 2 10.875 2z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMHeartFilledSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMHeartOutlineSvg = function _iconsMHeartOutlineSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.875 2C13.345 2 15 4.235 15 6.316 15 10.541 8.125 14 8 14s-7-3.459-7-7.684C1 4.235 2.656 2 5.125 2 6.537 2 7.465 2.896 8 3.5 8.536 2.896 9.463 2 10.875 2z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMHeartOutlineSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMHouseSearchSvg = function _iconsMHouseSearchSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14 6V1.756A.768.768 0 0 0 13.222 1h-1.444a.768.768 0 0 0-.778.756V3.5M1 7l5.987-4.66a1.677 1.677 0 0 1 2.025 0L15 7",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 6.5v6.92c0 .873.667 1.58 1.49 1.58H7m8 0-1-1m-2.5-5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMHouseSearchSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMHouseSvg = function _iconsMHouseSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m1.455 7.455 5.719-4.928a1.26 1.26 0 0 1 1.652 0l5.72 4.928M14 14H2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6.364V14m10-7.636V14",
    stroke: "currentColor",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2v3.273",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11v2",
    stroke: "currentColor",
    strokeWidth: "4",
    strokeLinecap: "round"
  }));
};

_iconsMHouseSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMInfoCircleSvg = function _iconsMInfoCircleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8 15v0a7 7 0 0 1-7-7v0a7 7 0 0 1 7-7v0a7 7 0 0 1 7 7v0a7 7 0 0 1-7 7z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.889v-3.89H7m.805-3.11a.195.195 0 1 0 .002.389.195.195 0 0 0-.002-.389",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMInfoCircleSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMInvoiceSvg = function _iconsMInvoiceSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12.4 15H3.6c-.884 0-1.6-.696-1.6-1.556V2.556C2 1.696 2.716 1 3.6 1h8.8c.884 0 1.6.696 1.6 1.556v10.888c0 .86-.716 1.556-1.6 1.556z",
    stroke: "currentColor",
    strokeWidth: "1.944",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.264 10.283c.259.424.701.717 1.236.717h1.096a1.404 1.404 0 0 0 .341-2.765l-1.874-.47A1.405 1.405 0 0 1 7.404 5H8.5c.533 0 .975.292 1.233.714",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4.011h0M8 12h0",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round"
  }));
};

_iconsMInvoiceSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMKebabSvg = function _iconsMKebabSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8 14.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zm0-6a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zm0-6a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMKebabSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMKeysSvg = function _iconsMKeysSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m7 4.097.337-.362c.912-.98 2.39-.98 3.303 0l3.513 3.775c1.13 1.214 1.13 3.181 0 4.395l-.172.185c-1.13 1.213-2.96 1.213-4.09 0L7.156 9.15",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.946 9.81A3.6 3.6 0 0 1 1 6.6C1 4.612 2.567 3 4.5 3S8 4.612 8 6.6a3.6 3.6 0 0 1-1.944 3.21v-.002l-.001 3.595a.809.809 0 0 1-.228.562l-.78.802a.76.76 0 0 1-1.095 0l-.78-.805a.81.81 0 0 1-.228-.564l.002-3.59",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.498 6.25a.25.25 0 1 0 .004.5.25.25 0 0 0-.004-.5M4.5 6 4 3.5C4 2.5 4.98 1 6.5 1 7 1 8.2.9 9 2.5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMKeysSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMLoaderProgressSvg = function _iconsMLoaderProgressSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1 8a7 7 0 1 0 7-7",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round"
  }));
};

_iconsMLoaderProgressSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMLoaderSvg = function _iconsMLoaderSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 1a7 7 0 1 0 7 7",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.504 1.937s0 0 0 0v.001s0 0 0 0 0 0 0 0M14.067 4.5s0 0 0 0v.001s0 0 0 0V4.5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMLoaderSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMLocationMarkerSvg = function _iconsMLocationMarkerSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8 9v0a2 2 0 0 1-2-2v0a2 2 0 0 1 2-2v0a2 2 0 0 1 2 2v0a2 2 0 0 1-2 2z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8 15s-6-3-6-8.556C2 3.438 4.686 1 8 1s6 2.438 6 5.444C14 11.5 8 15 8 15z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMLocationMarkerSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMLockClosedSvg = function _iconsMLockClosedSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12.286 15H3.714C2.767 15 2 14.254 2 13.333V6.667C2 5.746 2.767 5 3.714 5h8.572C13.233 5 14 5.746 14 6.667v6.666c0 .921-.767 1.667-1.714 1.667z",
    stroke: "currentColor",
    strokeWidth: "2.03",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 5V3.667C11 2.194 9.657 1 8 1v0C6.343 1 5 2.194 5 3.667V5m2.999 4.5a.25.25 0 1 0 .002.5A.25.25 0 0 0 8 9.5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMLockClosedSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMLockOpenSvg = function _iconsMLockOpenSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12.286 15H3.714C2.767 15 2 14.268 2 13.364V7.636C2 6.732 2.767 6 3.714 6h8.572C13.233 6 14 6.732 14 7.636v5.728c0 .904-.767 1.636-1.714 1.636z",
    stroke: "currentColor",
    strokeWidth: "2.002",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 4c0-1.657-1.366-3-3.051-3A3.036 3.036 0 0 0 5 3.267M11 6V4",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMLockOpenSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMMessagesQuestionSvg = function _iconsMMessagesQuestionSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1 7.388c0 2.095 1.104 3.939 2.8 5.101-.002.668 0 1.567 0 2.511l2.746-1.364c.47.09.955.14 1.454.14 3.852 0 7-2.844 7-6.388S11.852 1 8 1 1 3.844 1 7.388z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5.476C6.5 4.66 7.172 4 8 4s1.5.66 1.5 1.477c0 .591-.371.912-.742 1.157-.38.251-.758.578-.758 1.182V8m0 2.482a.119.119 0 0 0-.12.12.12.12 0 1 0 .24 0 .12.12 0 0 0-.12-.12",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMMessagesQuestionSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMMobileSvg = function _iconsMMobileSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6 2v1.44a.446.446 0 0 0 .4.48h3.2a.446.446 0 0 0 .4-.48V2M6 12h4",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.333 15H4.667C3.747 15 3 14.303 3 13.444V2.555C3 1.696 3.746 1 4.667 1h6.666C12.253 1 13 1.696 13 2.555v10.89c0 .858-.746 1.555-1.667 1.555z",
    stroke: "currentColor",
    strokeWidth: "1.944",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMMobileSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMNoteSvg = function _iconsMNoteSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3.5 14h6.879a1.6 1.6 0 0 0 1.06-.39l2.121-1.886c.282-.25.44-.59.44-.943V3.333C14 2.597 13.329 2 12.5 2h-9C2.671 2 2 2.597 2 3.333v9.334C2 13.403 2.671 14 3.5 14z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10h-3.2a.8.8 0 0 0-.8.8V14",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMNoteSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMOpenSvg = function _iconsMOpenSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.111 1H15v3.889M9.556 6.444 15 1m-1 8.313v4.062c0 .898-.727 1.625-1.625 1.625h-9.75A1.625 1.625 0 0 1 1 13.375v-9.75C1 2.727 1.727 2 2.625 2h4.063",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMOpenSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMPaperClipSvg = function _iconsMPaperClipSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10 12V5.605C10 4.721 9.332 4.003 8.506 4 7.676 3.996 7 4.716 7 5.605V11M4 4.8v7.24M13 5v6m-3 1v.375C10 13.825 8.657 15 7 15s-3-1.175-3-2.625V12",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 5v0c0-2.209-2.015-4-4.5-4v0C6.015 1 4 2.791 4 5v0",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMPaperClipSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMPeopleSvg = function _iconsMPeopleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1 13.6v-.321C1 11.696 2.2 10.4 3.667 10.4h2.666C7.8 10.4 9 11.696 9 13.279v.321m2-3.89h2.036c1.113 0 1.964.922 1.964 2.035v.146",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "4.9",
    cy: "5.5",
    r: "2.5",
    stroke: "currentColor",
    strokeWidth: "2.083"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "11.9",
    cy: "5.5",
    r: "1.5",
    stroke: "currentColor",
    strokeWidth: "2"
  }));
};

_iconsMPeopleSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMPersonSvg = function _iconsMPersonSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M2 14c0-1.704 1.727-3 3.799-3H10.2c2.16 0 3.8 1.364 3.8 3",
    stroke: "currentColor",
    strokeWidth: "2.143",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.901 2.853c1.199 1.21 1.199 3.13 0 4.267-1.198 1.138-3.1 1.209-4.229 0-1.127-1.209-1.198-3.129 0-4.267a3.046 3.046 0 0 1 4.23 0",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMPersonSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMPinSvg = function _iconsMPinSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 15v-3",
    stroke: "currentColor",
    strokeWidth: "1.944",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.414 7H5.581c-1.153 0-2.155.756-2.429 1.831l-.11.437c-.107.417-.007.859.27 1.197A1.48 1.48 0 0 0 4.458 11h7.084c.447 0 .87-.197 1.147-.535a1.36 1.36 0 0 0 .27-1.197l-.111-.437c-.274-1.076-1.28-1.833-2.434-1.831v0z",
    stroke: "currentColor",
    strokeWidth: "2.083",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.249 7-.674-2.915a.92.92 0 0 1 .29-.827l.835-.715c.258-.222.364-.607.261-.957-.102-.35-.388-.586-.711-.586h-4.5c-.323 0-.61.236-.711.586-.103.35.003.735.261.957l.836.715a.92.92 0 0 1 .289.827L5.751 7",
    stroke: "currentColor",
    strokeWidth: "1.909",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMPinSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMPlaceholderSvg = function _iconsMPlaceholderSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "7",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeDasharray: "1 4"
  }));
};

_iconsMPlaceholderSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMPrinterSvg = function _iconsMPrinterSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4 5V1.8a.8.8 0 0 1 .8-.8h6.4a.8.8 0 0 1 .8.8V5m-8 7H2.556C1.696 12 1 11.304 1 10.444V6.556C1 5.696 1.696 5 2.556 5h10.888C14.304 5 15 5.696 15 6.556v3.888c0 .86-.696 1.556-1.556 1.556H12",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4 10h8v4.306c0 .383-.358.694-.8.694H4.8c-.442 0-.8-.311-.8-.694V10z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMPrinterSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMReceiptSvg = function _iconsMReceiptSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11 4H5m6 3H5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2 14.136V1.82c0-.452.336-.82.75-.82h10.5c.414 0 .75.368.75.821v12.315c0 .305-.375.864-.75.864l-1.75-1-1.25.957c-.106.057-.644.057-.75 0L8 14l-1.5.957c-.106.057-.644.057-.75 0L4.5 14l-1.75 1c-.375 0-.75-.559-.75-.864z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10H5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMReceiptSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMRefreshSvg = function _iconsMRefreshSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.999 1a7 7 0 1 0 3.346.851",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.345 4.542V1.448h3.094",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMRefreshSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMRulerSvg = function _iconsMRulerSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m4.684 8.116 3.2 3.2A.4.4 0 0 1 7.6 12H4.4a.4.4 0 0 1-.4-.4V8.4a.4.4 0 0 1 .683-.283z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m3.656 1.456 10.888 10.888a1.556 1.556 0 0 1-1.1 2.656H2.556C1.696 15 1 14.303 1 13.444V2.556a1.556 1.556 0 0 1 2.656-1.1z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 6 1-1m1 3 1-1m1 3 1-1m1 3 1-1M4 4l1-1",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMRulerSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMSearchSvg = function _iconsMSearchSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.396 3.28a5.738 5.738 0 1 1-8.115 8.116 5.738 5.738 0 0 1 8.115-8.115M14.4 14.4l-3.008-3.008",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMSearchSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMSettingsGearSvg = function _iconsMSettingsGearSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.1 8H15M1 8h1.225M6.95 9.817 4.5 14.062m7-12.124-.613 1.06M6.95 6.183 4.5 1.938m7 12.124-.613-1.061m1.196-9.084a5.775 5.775 0 1 1-8.166 8.166 5.775 5.775 0 0 1 8.166-8.166",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.938 11.5 1.06-.613M14.062 4.5l-1.061.613M8 15v-1.225M8 1v1.225m6.062 9.275-1.061-.613M1.938 4.5l1.06.613",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMSettingsGearSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMSettingsSvg = function _iconsMSettingsSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.414 7.414a2 2 0 1 1-2.828-2.828 2 2 0 0 1 2.828 2.828M12 3.2V2m0 12V8m-6.586 3.414a2 2 0 1 1-2.828-2.828 2 2 0 0 1 2.828 2.828M4 2v5.2m0 5.6V14",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMSettingsSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMSolSvg = function _iconsMSolSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.121 5.879A3 3 0 1 1 5.88 10.12a3 3 0 0 1 4.24-4.24M8 2V1m0 14v-1m4-10 1-1M3 13l1-1m10-4h1M1 8h1m10 4 1 1M3 3l1 1",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMSolSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMSortSvg = function _iconsMSortSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6 4 4 2 2 4m2 10V3m6 9 2 2 2-2M12 2v11",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMSortSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMSpannerSvg = function _iconsMSpannerSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.862 1.054c1.111.488 1.912 1.28 2.465 2.256 1.427 2.418.518 5.392-2.097 6.86-2.615 1.467-6.073.944-7.978-1.206C1.83 7.336 1.6 5.137 2.66 3.31c.555-.977 1.36-1.769 2.473-2.256a.675.675 0 0 1 .586.027.515.515 0 0 1 .281.452C5.998 1.717 6 6 6 6h4V1.533a.515.515 0 0 1 .28-.449.675.675 0 0 1 .582-.03z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11v4h6v-4",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMSpannerSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMTextBoldSvg = function _iconsMTextBoldSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3 2h5.875a3 3 0 0 1 3 3v0a3 3 0 0 1-3 3H3V2zm0 6h7a3 3 0 0 1 3 3v0a3 3 0 0 1-3 3H3V8z",
    stroke: "currentColor",
    strokeWidth: "2.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMTextBoldSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMTextBulletedListSvg = function _iconsMTextBulletedListSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1m0 8a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M6 4h9m-9 8h9",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMTextBulletedListSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMTextItalicsSvg = function _iconsMTextItalicsSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m9.5 2-3 12m3.5 0H3M6 2h7",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMTextItalicsSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMTextLinkSvg = function _iconsMTextLinkSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.505 14.005 7c1.327-1.326 1.327-3.678 0-5.005C12.68.668 10.327.674 9 2L7.5 3.5M6 10l4-4M3.5 7.5 2 9c-1.326 1.326-1.332 3.678-.005 5.005C3.32 15.332 5.673 15.326 7 14l1.5-1.5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMTextLinkSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMTextNumberedListSvg = function _iconsMTextNumberedListSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M2.34 1.636h-.978l-1.076.67v.911l.975-.596h.026V6h1.052V1.636zM.322 14h3.23v-.85H1.783v-.028l.522-.481c.946-.825 1.194-1.245 1.194-1.745 0-.787-.642-1.32-1.633-1.32-.965 0-1.61.557-1.608 1.445h1c0-.394.242-.622.604-.622.356 0 .614.22.614.58 0 .326-.205.547-.563.869L.322 13.241V14z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4h9m-9 8h9",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMTextNumberedListSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMUnpinSvg = function _iconsMUnpinSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m3.05 12.95 2.122-2.122",
    stroke: "currentColor",
    strokeWidth: "1.944",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.95 14.75 1 9.8",
    stroke: "currentColor",
    strokeWidth: "1.944",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.414 9 6.997 5.582c-.815-.814-2.06-.989-3.012-.422l-.388.23c-.37.22-.612.603-.655 1.037-.044.435.116.873.432 1.19l5.01 5.009c.316.316.754.476 1.189.432a1.357 1.357 0 0 0 1.037-.655l.23-.388c.568-.954.392-2.2-.426-3.015v0z",
    stroke: "currentColor",
    strokeWidth: "2.083",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.298 8.883 1.584-2.537a.92.92 0 0 1 .79-.38l1.096.084c.34.026.686-.172.862-.491.175-.32.14-.69-.09-.918L11.36 1.46c-.228-.228-.598-.264-.918-.088-.32.175-.517.522-.491.86l.085 1.098a.92.92 0 0 1-.38.79L7.117 5.702",
    stroke: "currentColor",
    strokeWidth: "1.909",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMUnpinSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMWarningCircleSvg = function _iconsMWarningCircleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8 1v0a7 7 0 0 1 7 7v0a7 7 0 0 1-7 7v0a7 7 0 0 1-7-7v0a7 7 0 0 1 7-7z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8V5m.005 6a.005.005 0 0 0-.005.005c0 .003.002.005.005.005a.005.005 0 0 0 .005-.005.005.005 0 0 0-.005-.005",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMWarningCircleSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsMWarningSvg = function _iconsMWarningSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m8 9.25-.25-5.5z",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.003 12a.003.003 0 1 0 0 .007.003.003 0 0 0 .004-.004.003.003 0 0 0-.004-.003",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsMWarningSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSActivitySvg = function _iconsSActivitySvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1 6h2l1.5-4 3 8L9 6h2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSActivitySvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSAddSvg = function _iconsSAddSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6 10V2m4 4H2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSAddSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSAreaSvg = function _iconsSAreaSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1 1h7m3 10V4",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "1",
    y: "4",
    width: "7",
    height: "7",
    rx: ".5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSAreaSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSArrowBackSvg = function _iconsSArrowBackSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M3 1 1 3l2 2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 3h6c2.367 0 4 1.33 4 3.5S9.367 10 7 10H2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSArrowBackSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSArrowDownCircleSvg = function _iconsSArrowDownCircleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1 6v0a5 5 0 0 1 5-5v0a5 5 0 0 1 5 5v0a5 5 0 0 1-5 5v0a5 5 0 0 1-5-5z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8V4m2 2L6 8 4 6",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSArrowDownCircleSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSArrowDownSvg = function _iconsSArrowDownSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6 10V2M3 7l3 3 3-3",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSArrowDownSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSArrowLeftCircleSvg = function _iconsSArrowLeftCircleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6 1v0a5 5 0 0 1 5 5v0a5 5 0 0 1-5 5v0a5 5 0 0 1-5-5v0a5 5 0 0 1 5-5z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6h4M6 8 4 6l2-2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSArrowLeftCircleSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSArrowLeftSvg = function _iconsSArrowLeftSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M2 6h8M5 3 2 6l3 3",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSArrowLeftSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSArrowRightCircleSvg = function _iconsSArrowRightCircleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6 11v0a5 5 0 0 1-5-5v0a5 5 0 0 1 5-5v0a5 5 0 0 1 5 5v0a5 5 0 0 1-5 5z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6H4m2-2 2 2-2 2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSArrowRightCircleSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSArrowRightSvg = function _iconsSArrowRightSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10 6H2m5-3 3 3-3 3",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSArrowRightSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSArrowUpCircleSvg = function _iconsSArrowUpCircleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11 6v0a5 5 0 0 1-5 5v0a5 5 0 0 1-5-5v0a5 5 0 0 1 5-5v0a5 5 0 0 1 5 5z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4v4M4 6l2-2 2 2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSArrowUpCircleSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSArrowUpSvg = function _iconsSArrowUpSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6 2v8M3 5l3-3 3 3",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSArrowUpSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSBuildingsSvg = function _iconsSBuildingsSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M2.001 10V1.5c0-.276-.052-.5.5-.5H9.5c.552 0 .5.224.5.5V10m1 1H1",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7h2M5 4h2m-1 6v1",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round"
  }));
};

_iconsSBuildingsSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSCheckSvg = function _iconsSCheckSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4 5.125 8 3 6",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSCheckSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSChevronDownSvg = function _iconsSChevronDownSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m3 5 3 3 3-3",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSChevronDownSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSChevronLeftSvg = function _iconsSChevronLeftSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7 3 4 6l3 3",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSChevronLeftSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSChevronRightSvg = function _iconsSChevronRightSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m5 3 3 3-3 3",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSChevronRightSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSChevronUpSvg = function _iconsSChevronUpSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m3 7 3-3 3 3",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSChevronUpSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSCircleFilledSvg = function _iconsSCircleFilledSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z",
    fill: "currentColor"
  }));
};

_iconsSCircleFilledSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSCircleOutlineSvg = function _iconsSCircleOutlineSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z",
    stroke: "currentColor"
  }));
};

_iconsSCircleOutlineSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSClockBackSvg = function _iconsSClockBackSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6 4.5V6l1 1",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 1.67A5 5 0 1 1 1 6",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 1v2h2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSClockBackSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSClockSvg = function _iconsSClockSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "6",
    r: "5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4v2l1 1",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSClockSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSCollapseSvg = function _iconsSCollapseSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11 1 8 4m2 0H8V2M2 8h2v2m-3 1 3-3M2 5V2.857C2 2.384 2.384 2 2.857 2H5m5 5v2.143c0 .473-.336.857-.75.857H7",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSCollapseSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSComputerSvg = function _iconsSComputerSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M9.889 8H2.11C1.497 8 1 7.553 1 7V2c0-.552.497-1 1.111-1H9.89c.613 0 1.11.448 1.11 1v5c0 .553-.497 1-1.111 1z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5 8 .5 3M4.5 8 4 11m-1 0h6",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSComputerSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSCrossSmallSvg = function _iconsSCrossSmallSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m8.5 3.5-5 5m5 0-5-5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSCrossSmallSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSDashSvg = function _iconsSDashSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9 6H3",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSDashSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSDeleteCrossSvg = function _iconsSDeleteCrossSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M2 4h8M9 4v5.923C9 10.518 8.553 11 8 11H4c-.553 0-1-.482-1-1.077V4m4.5-3h-3M6 8V7",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSDeleteCrossSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSDocumentLegalSvg = function _iconsSDocumentLegalSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M2 2.11C2 1.498 2.448 1 3 1h5.998c.553 0 1 .497 1 1.11v1.667M3 10.997c-.552 0-1-.496-1-1.11l.002-6.108V2.113c0-.614.447-1.11 1-1.11H9c.552 0 1 .496 1 1.11v7.776C10 10.503 9.552 11 9 11l-5-.004-1 .002zM5 4h2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 7a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSDocumentLegalSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSDownloadSvg = function _iconsSDownloadSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6 8V1m4 10H2m7-6L6 8 3 5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSDownloadSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSDragHandleSvg = function _iconsSDragHandleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "2",
    r: "1",
    transform: "rotate(-180 4 2)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "6",
    r: "1",
    transform: "rotate(-180 4 6)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "10",
    r: "1",
    transform: "rotate(-180 4 10)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "2",
    r: "1",
    transform: "rotate(-180 8 2)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "6",
    r: "1",
    transform: "rotate(-180 8 6)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "10",
    r: "1",
    transform: "rotate(-180 8 10)",
    fill: "currentColor"
  }));
};

_iconsSDragHandleSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSEditSvg = function _iconsSEditSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m1.251 8.102 6.85-6.851a.857.857 0 0 1 1.212 0l1.436 1.436a.857.857 0 0 1 0 1.212L8.324 6.324l-4.426 4.425a.853.853 0 0 1-.605.251H1V8.707c0-.227.09-.445.251-.605z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 4 1 1",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSEditSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSEllipsisSvg = function _iconsSEllipsisSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M6.5 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M2 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSEllipsisSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSEnvelopeSvg = function _iconsSEnvelopeSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1.909 2.136h8.182a.91.91 0 0 1 .909.91v5.908a.909.909 0 0 1-.909.91H1.91A.909.909 0 0 1 1 8.953V3.046a.91.91 0 0 1 .909-.91z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 4.006 5.466 6a.901.901 0 0 0 1.048 0L10 4",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSEnvelopeSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSExpandSvg = function _iconsSExpandSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9 1h2v2M7.5 4.5 11 1M3 11H1V9m3.5-1.5L1 11m1-6V2.857C2 2.384 2.384 2 2.857 2H5m5 5v2.143c0 .473-.336.857-.75.857H7",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSExpandSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSFileSvg = function _iconsSFileSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5 8h2M5 5h1",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3 1h4.586a.95.95 0 0 1 .707.326l1.414 1.57c.188.209.293.492.293.786V9.89c0 .613-.447 1.11-1 1.11H3c-.553 0-1-.497-1-1.111V2.11C2 1.497 2.447 1 3 1z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3H8.4a.4.4 0 0 1-.4-.4V1.5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSFileSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSHamburgerSvg = function _iconsSHamburgerSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1 6h10M1 9h10M1 3h10",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSHamburgerSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSHeartFilledSvg = function _iconsSHeartFilledSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 2C10.264 2 11 3.676 11 5.237 11 8.406 6.09 11 6 11c-.09 0-5-2.594-5-5.763C1 3.677 1.736 2 3.5 2 5 2 5.617 3.547 6 4c.383-.453 1-2 2.5-2z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSHeartFilledSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSHeartOutlineSvg = function _iconsSHeartOutlineSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.053 2C9.817 2 11 3.676 11 5.237 11 8.406 6.09 11 6 11c-.09 0-5-2.594-5-5.763C1 3.677 2.183 2 3.947 2 4.955 2 5.617 2.672 6 3.125 6.383 2.672 7.045 2 8.053 2z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSHeartOutlineSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSHouseSearchSvg = function _iconsSHouseSearchSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m1 4 4.277-2.796a1.383 1.383 0 0 1 1.446 0L11 4M2 4v5.884c0 .617.4 1.116.894 1.116H4m6.75-.25L10 10M8 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1v2",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round"
  }));
};

_iconsSHouseSearchSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSHouseSvg = function _iconsSHouseSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m1 4.927 4.29-3.695a.945.945 0 0 1 1.239 0l4.29 3.695M11 10H1",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 4v7m8-7v7",
    stroke: "currentColor",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 1v2M6 7v3",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round"
  }));
};

_iconsSHouseSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSInfoCircleSvg = function _iconsSInfoCircleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6 11v0a5 5 0 0 1-5-5v0a5 5 0 0 1 5-5v0a5 5 0 0 1 5 5v0a5 5 0 0 1-5 5z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8V6.5m-.065-2.604a.065.065 0 1 0 0-.13.065.065 0 0 0 0 .13",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSInfoCircleSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSInvoiceSvg = function _iconsSInvoiceSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4 2.011h0M4 10h0",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.264 8.283C2.523 8.707 2.965 9 3.5 9h1.096a1.404 1.404 0 0 0 .341-2.765l-1.874-.47A1.405 1.405 0 0 1 3.404 3H4.5c.533 0 .975.292 1.233.714M9 3h1M9 6h1M9 9h1",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSInvoiceSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSKebabSvg = function _iconsSKebabSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0-4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m0-4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSKebabSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSKeysSvg = function _iconsSKeysSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4.286 7.107C3.16 6.664 2 6.157 2 4.5 2 3 3.143 1 6 1s4 2.009 4 3.5-1.161 2.163-2.286 2.606v2.696a.543.543 0 0 1-.224.422l-.763.601c-.297.234-1.158.237-1.455.003l-.764-.603a.543.543 0 0 1-.222-.423V7.107z",
    stroke: "currentColor",
    strokeWidth: "2.056",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4.5a1 1 0 1 0 2 0 1 1 0 0 0-2 0z",
    fill: "currentColor"
  }));
};

_iconsSKeysSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSLoaderSvg = function _iconsSLoaderSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6 1a5 5 0 1 0 5 5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.575 2.5a.005.005 0 1 0 0 .01.005.005 0 0 0 0-.01",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSLoaderSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSLocationMarkerSvg = function _iconsSLocationMarkerSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6 6v0a1 1 0 0 1-1-1v0a1 1 0 0 1 1-1v0a1 1 0 0 1 1 1v0a1 1 0 0 1-1 1z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6 11S2 8.857 2 4.889C2 2.74 3.79 1 6 1s4 1.741 4 3.889C10 8.5 6 11 6 11z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSLocationMarkerSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSMobileSvg = function _iconsSMobileSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.75 10h.5m-.5-8h.5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8 11H4c-.552 0-1-.498-1-1.111V2.11C3 1.497 3.448 1 4 1h4c.552 0 1 .497 1 1.111V9.89C9 10.503 8.552 11 8 11z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSMobileSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSNoteSvg = function _iconsSNoteSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3 10h4.586c.265 0 .52-.094.707-.26l1.414-1.257A.842.842 0 0 0 10 7.854V2.89C10 2.398 9.553 2 9 2H3c-.553 0-1 .398-1 .889V9.11c0 .491.447.889 1 .889z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7H7.6a.6.6 0 0 0-.6.6V10",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSNoteSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSOpenSvg = function _iconsSOpenSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 1h3v3M7 5l4-4m-1 6.063v2.812C10 10.497 9.497 11 8.875 11h-6.75A1.125 1.125 0 0 1 1 9.875v-6.75C1 2.503 1.503 2 2.125 2h2.813",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSOpenSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSPaperClipSvg = function _iconsSPaperClipSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8 9V5.003C8 4.451 7.263 4 6.506 4 5.75 4 5 4.448 5 5.003v3.372M2 4v5m9-5v4",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7.5v1.75C7.5 10.5 6.437 11 5 11c-1.438 0-2.5-.5-3-1.75V9m9-5c0-1.657-2.188-3-4.5-3C4.187 1 2 2.343 2 4",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSPaperClipSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSPersonSvg = function _iconsSPersonSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1 11c0-1.705 1.439-3 3.165-3h3.67C9.633 8 11 9.364 11 11M7.4 1.569c.8.806.8 2.086 0 2.844-.798.759-2.067.806-2.818 0-.752-.806-.8-2.086 0-2.844a2.031 2.031 0 0 1 2.819 0",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSPersonSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSPinSvg = function _iconsSPinSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6 11V9",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7.931 5H4.065c-.922 0-1.725.756-1.943 1.831l-.089.437c-.085.417-.005.859.216 1.197.221.338.56.535.918.535h5.666c.358 0 .697-.197.918-.535.221-.338.3-.78.216-1.197l-.089-.437C9.659 5.755 8.855 4.998 7.931 5v0z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.249 5-.674-1.943c-.046-.21.065-.423.29-.551l.835-.478c.258-.147.364-.404.261-.637C8.86 1.157 8.573 1 8.25 1h-4.5c-.323 0-.61.157-.711.39-.103.234.003.49.261.638l.836.478c.224.128.335.34.289.55L3.751 5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSPinSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSPlaceholderSvg = function _iconsSPlaceholderSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "6",
    cy: "6",
    r: "5",
    stroke: "currentColor",
    strokeWidth: "1.952",
    strokeLinecap: "round",
    strokeDasharray: "0.85 3.42"
  }));
};

_iconsSPlaceholderSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSPrinterSvg = function _iconsSPrinterSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M3 3V1.4c0-.22.269-.4.6-.4h4.8c.331 0 .6.18.6.4V3M3 9h-.889A1.11 1.11 0 0 1 1 7.889V5.11A1.11 1.11 0 0 1 2.111 4H9.89A1.11 1.11 0 0 1 11 5.111V7.89A1.11 1.11 0 0 1 9.889 9H9",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3 7h6v3.444c0 .307-.269.556-.6.556H3.6c-.331 0-.6-.249-.6-.556V7z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSPrinterSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSReceiptSvg = function _iconsSReceiptSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7 4H5M2 1.586v8.797c0 .218.25.617.5.617l2-1L6 11l1.5-1 2 1c.25 0 .5-.4.5-.617V1.586C10 1.263 9.776 1 9.5 1h-7c-.276 0-.5.263-.5.586zM6 7H5",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSReceiptSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSSettingsSvg = function _iconsSSettingsSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.06 5.56a1.5 1.5 0 1 1-2.12-2.12 1.5 1.5 0 0 1 2.12 2.12M9 2.4V1m0 10V6M4.06 8.56a1.5 1.5 0 1 1-2.12-2.12 1.5 1.5 0 0 1 2.12 2.12M3 1v4.4m0 4.2V11",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSSettingsSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSSpannerSvg = function _iconsSSpannerSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.552 2.617C9.182 1.933 8.74 1.379 8 1.038a.43.43 0 0 0-.388.02.363.363 0 0 0-.187.315L7 4H5s-.424-2.498-.422-2.627a.363.363 0 0 0-.187-.316A.43.43 0 0 0 4 1.038c-.742.341-1.19.895-1.56 1.579-.706 1.279-.553 2.818.394 3.958 1.27 1.505 3.576 1.87 5.32.843 1.742-1.027 2.349-3.108 1.398-4.801z",
    stroke: "currentColor",
    strokeWidth: "1.972",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8v3h4V8",
    stroke: "currentColor",
    strokeWidth: "1.872",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSSpannerSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsSWarningCircleSvg = function _iconsSWarningCircleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6 1v0a5 5 0 0 1 5 5v0a5 5 0 0 1-5 5v0a5 5 0 0 1-5-5v0a5 5 0 0 1 5-5z",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 5V4m.005 4a.005.005 0 1 0 0 .01.005.005 0 0 0 0-.01",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsSWarningCircleSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlActivitySvg = function _iconsXlActivitySvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M3 16.5h5l5-12 6 23 5-11h5",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlActivitySvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlAreaSvg = function _iconsXlAreaSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M2 5h20",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.5v3m21-3v3m5 5h3",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 28.5v-17",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 28.5h3",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "1.5",
    y: "11.5",
    width: "21",
    height: "17",
    rx: "1.6",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlAreaSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlArrowDownCircleSvg = function _iconsXlArrowDownCircleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.5 16v0C2.5 8.543 8.543 2.5 16 2.5v0c7.456 0 13.5 6.043 13.5 13.5v0c0 7.456-6.044 13.5-13.5 13.5v0C8.543 29.5 2.5 23.456 2.5 16z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 22.5v-13m4.5 8.5L16 22.5 11.5 18",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlArrowDownCircleSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlArrowLeftCircleSvg = function _iconsXlArrowLeftCircleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16 2.5v0c7.456 0 13.5 6.043 13.5 13.5v0c0 7.456-6.044 13.5-13.5 13.5v0C8.543 29.5 2.5 23.456 2.5 16v0C2.5 8.543 8.543 2.5 16 2.5z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16h13M14 20.5 9.5 16l4.5-4.5",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlArrowLeftCircleSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlArrowRightCircleSvg = function _iconsXlArrowRightCircleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16 29.5v0C8.543 29.5 2.5 23.456 2.5 16v0C2.5 8.543 8.543 2.5 16 2.5v0c7.456 0 13.5 6.043 13.5 13.5v0c0 7.456-6.044 13.5-13.5 13.5z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16h-13m8.5-4.5 4.5 4.5-4.5 4.5",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlArrowRightCircleSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlArrowUpCircleSvg = function _iconsXlArrowUpCircleSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M29.5 16v0c0 7.456-6.044 13.5-13.5 13.5v0C8.543 29.5 2.5 23.456 2.5 16v0C2.5 8.543 8.543 2.5 16 2.5v0c7.456 0 13.5 6.043 13.5 13.5z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10v12.5M11.5 14 16 9.5l4.5 4.5",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlArrowUpCircleSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlBuildingsSvg = function _iconsXlBuildingsSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 28.5V4.833c0-.736.672-1.333 1.5-1.333h10c.828 0 1.5.597 1.5 1.333V28.5m8 0V11.174c0-.648-.654-1.174-1.46-1.174H23.5m-15 0H3.122c-.896 0-1.622.526-1.622 1.174V28.5m15-19h-1m1 6h-1m1 6h-1m15 7h-29",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlBuildingsSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlCalendarSvg = function _iconsXlCalendarSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4.5v4m13-4v4m-20 6h27m-28-4a4 4 0 0 1 4-4h21a4 4 0 0 1 4 4v13a4 4 0 0 1-4 4h-21a4 4 0 0 1-4-4v-13z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlCalendarSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlCheckSvg = function _iconsXlCheckSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M25 10 14 22l-6-6",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlCheckSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlClockSvg = function _iconsXlClockSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m21 18-5.5-2",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "15.5",
    cy: "15.5",
    r: "14",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 16V7.5",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlClockSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlComputerSvg = function _iconsXlComputerSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M27.278 23.5H4.722c-1.78 0-3.222-1.406-3.222-3.143V4.643C1.5 2.906 2.942 1.5 4.722 1.5h22.556c1.78 0 3.222 1.406 3.222 3.143v15.714c0 1.737-1.442 3.143-3.222 3.143z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.2 24 .8 6.4M12.8 24l-.8 6.4m-3.5.1h15m7-13h-29",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlComputerSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlDashboardSvg = function _iconsXlDashboardSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "17",
    r: "3.5",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 9 19 13.5m6.5 2.5h-1m-18 .014h1M16 6.5v2m-6.5 1 1 1",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15.449 1.508C7.72 1.83 1.595 8.14 1.5 15.876a14.365 14.365 0 0 0 5.982 11.708 6.217 6.217 0 0 0 3.641 1.12h9.564a6.102 6.102 0 0 0 3.562-1.083 14.39 14.39 0 0 0-8.8-26.113z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlDashboardSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlDocumentLegalSvg = function _iconsXlDocumentLegalSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4.722C3.5 2.942 4.899 1.5 6.624 1.5H25.37c1.726 0 3.124 1.442 3.124 3.222v4.832m-21.87 20.94c-1.725 0-3.124-1.442-3.124-3.222L3.506 9.56V4.728c0-1.78 1.398-3.222 3.124-3.222h18.746c1.725 0 3.124 1.442 3.124 3.222v22.55c0 1.78-1.399 3.222-3.124 3.222l-15.624-.012-3.128.006z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11 24.5v0A2.5 2.5 0 0 1 8.5 22v0a2.5 2.5 0 0 1 2.5-2.5v0a2.5 2.5 0 0 1 2.5 2.5v0a2.5 2.5 0 0 1-2.5 2.5z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.5h15m-15 6h10m.5 8h3.5",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlDocumentLegalSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlEnvelopeSvg = function _iconsXlEnvelopeSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4.136 4.5h23.727c1.456 0 2.637 1.167 2.637 2.606v17.79c0 1.439-1.18 2.604-2.636 2.604H4.136C2.68 27.502 1.5 26.335 1.5 24.896V7.106C1.5 5.666 2.68 4.5 4.136 4.5z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 6 12 9.325c1.112.795 2.886.794 4 0L30 6",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlEnvelopeSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlFileSvg = function _iconsXlFileSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16.5h15m-15 7h15",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7 1.5h13.776c.848 0 1.662.438 2.262 1.038l4.525 4.524c.6.6.938 1.415.938 2.263V27.3a3.2 3.2 0 0 1-3.2 3.2H7c-1.769 0-3.5-1.632-3.5-3.4V5c0-1.768 1.731-3.5 3.5-3.5z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 9.5h-5.7c-.994 0-1.8-.717-1.8-1.6V2m-12 8.5h7",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlFileSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlHamburgerSvg = function _iconsXlHamburgerSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15.5h23m-23 8h23m-23-16h23",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlHamburgerSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlHeartFilledSvg = function _iconsXlHeartFilledSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.955 3.5c5.115 0 8.545 4.711 8.545 9.098C30.5 21.503 16.26 28.5 16 28.5c-.26 0-14.5-6.997-14.5-15.902C1.5 8.211 4.93 3.5 10.045 3.5 12.97 3.5 14.89 5.388 16 6.662 17.11 5.388 19.03 3.5 21.955 3.5z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlHeartFilledSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlHeartOutlineSvg = function _iconsXlHeartOutlineSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M21.955 3.5c5.115 0 8.545 4.711 8.545 9.098C30.5 21.503 16.26 28.5 16 28.5c-.26 0-14.5-6.997-14.5-15.902C1.5 8.211 4.93 3.5 10.045 3.5 12.97 3.5 14.89 5.388 16 6.662 17.11 5.388 19.03 3.5 21.955 3.5z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlHeartOutlineSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlHouseSearchSvg = function _iconsXlHouseSearchSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 14v12.5c0 1.769 1.184 3 3 3h8m15 0-2.3-2.3M23 17.5a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11",
    stroke: "currentColor",
    strokeWidth: "3.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 12.5V2.3c0-.442-.336-.8-.75-.8h-4.5c-.414 0-.75.358-.75.8v5.2M1.5 15l13-11a2.62 2.62 0 0 1 3.41 0L30.5 15",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlHouseSearchSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlHouseSvg = function _iconsXlHouseSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m1.5 15 13-11a2.62 2.62 0 0 1 3.41 0L30.5 15",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 29V3.395c0-.442-.336-.8-.75-.8h-4.5c-.414 0-.75.358-.75.8v4.171M12.5 29.5v-8.462c0-.85.638-1.538 1.426-1.538h4.148c.788 0 1.426.689 1.426 1.538V29.5M3.5 14v15m27 .5h-29",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlHouseSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlInvoiceSvg = function _iconsXlInvoiceSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M25.5 30.5h-19c-1.886 0-3-1.832-3-3.6V4.5c0-1.768 1.114-3 3-3h19c1.886 0 3 1.232 3 3v23c0 1.768-1.114 3-3 3z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 7.5h2m-2 5h2m-2 5h2m-13 7h13M12.567 8.067v-1.6M12.5 18.5v2m-2.578-3.195c.414.706 1.122 1.195 1.978 1.195h1.754c1.241 0 2.246-1.048 2.246-2.339 0-1.073-.702-2.008-1.7-2.27l-3-.782c-.998-.262-1.7-1.197-1.7-2.27 0-1.29 1.007-2.339 2.246-2.339H13.5c.853 0 1.56.486 1.973 1.19",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlInvoiceSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlKeysSvg = function _iconsXlKeysSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m14.5 8.195.674-.725c1.825-1.96 4.781-1.96 6.606 0l7.026 7.55a6.35 6.35 0 0 1 0 8.636l-.344.344c-1.962 2-5.962 2-8.18 0l-5.47-5.698",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.392 20.087A7.2 7.2 0 0 1 1.5 13.666c0-3.976 3.134-7.2 7-7.2s7 3.224 7 7.2c0 2.82-1.702 5.238-3.998 6.419v-.003l-.002 7.19a1.618 1.618 0 0 1-.456 1.125L9.486 30c-.607.622-1.38.62-1.986-.002L5.94 28.39a1.62 1.62 0 0 1-.454-1.128l.003-7.179",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.496 12.5a.5.5 0 1 0 .008 1 .5.5 0 0 0-.008-1",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.5 12.5-.5-6c0-2 1.96-5 5-5 1 0 3.4.3 5 3.5",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlKeysSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlLocationMarkerSvg = function _iconsXlLocationMarkerSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16 17.5v0a4.5 4.5 0 0 1-4.5-4.5v0A4.5 4.5 0 0 1 16 8.5v0a4.5 4.5 0 0 1 4.5 4.5v0a4.5 4.5 0 0 1-4.5 4.5z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16 30.5S4.5 21.236 4.5 12.778C4.5 6.549 9.649 1.5 16 1.5s11.5 5.05 11.5 11.278C27.5 21.236 16 30.5 16 30.5z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlLocationMarkerSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlMobileSvg = function _iconsXlMobileSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.503 1.5v3c-.035.485.574.952.997 1h5c.5 0 1.032-.515.998-1v-3m-6.998 24h7",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M22.333 30.5H9.667c-1.75 0-3.167-1.443-3.167-3.222V4.722C6.5 2.942 7.918 1.5 9.667 1.5h12.666c1.75 0 3.167 1.443 3.167 3.222v22.556c0 1.78-1.418 3.222-3.167 3.222z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlMobileSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlNoteSvg = function _iconsXlNoteSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.75 29.5h14.904c.862 0 1.689-.305 2.298-.846l4.596-4.085c.61-.542.952-.803.952-1.569V6.389c0-1.596-1.454-2.889-3.25-2.889H6.75C4.954 3.5 3.5 4.793 3.5 6.389V26.61c0 1.596 1.454 2.889 3.25 2.889z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5 21.5H23c-.883 0-1.5.617-1.5 1.5v6.5",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlNoteSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlPersonSvg = function _iconsXlPersonSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 28.5c0-4.546 3.597-8 7.914-8h9.172c4.497 0 7.914 3.636 7.914 8M20.203 5.207c2.396 2.417 2.396 6.257 0 8.533-2.397 2.275-6.203 2.417-8.458 0-2.256-2.418-2.397-6.258 0-8.533a6.093 6.093 0 0 1 8.458 0",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlPersonSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlPlaceholderSvg = function _iconsXlPlaceholderSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "15",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeDasharray: "3 4"
  }));
};

_iconsXlPlaceholderSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlPrinterSvg = function _iconsXlPrinterSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.5V3.1c0-.883.762-1.6 1.7-1.6h13.6c.938 0 1.7.717 1.7 1.6v6.4M7.5 24H4.722C2.942 24 1.5 22.568 1.5 20.8v-8c0-1.768 1.442-3.2 3.222-3.2h22.556c1.78 0 3.222 1.432 3.222 3.2v8c0 1.768-1.442 3.2-3.222 3.2H24.5",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7.5 19.5h17v9.43c0 .867-.762 1.57-1.7 1.57H9.2c-.938 0-1.7-.703-1.7-1.57V19.5z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.5h2",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlPrinterSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlReceiptSvg = function _iconsXlReceiptSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 8.5h-13m13 6h-13",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3.1 28.71V3.2c0-.938.714-1.7 1.594-1.7h22.312c.88 0 1.594.762 1.594 1.7v25.51c0 .633-.797 1.79-1.594 1.79L24 28.5l-3.369 1.91c-.224.12-1.369.12-1.593 0L16 28.5l-3.337 1.91c-.225.12-1.37.12-1.594 0L8 28.5l-3.306 2c-.797 0-1.594-1.157-1.594-1.79z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 20.5h-8",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlReceiptSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlSettingsSvg = function _iconsXlSettingsSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M25.279 14.828a4 4 0 1 1-5.657-5.656 4 4 0 0 1 5.657 5.656M22.45 8V2.5m0 27V16m-10.122 6.828a4 4 0 1 1-5.656-5.656 4 4 0 0 1 5.656 5.656M9.5 2.5V16m0 8v5.5",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlSettingsSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlSpannerSvg = function _iconsXlSpannerSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M20.938 1.614c2.13 1.024 4.211 2.687 5.273 4.736 2.734 5.079.991 11.324-4.02 14.405-5.012 3.082-11.641 1.985-15.292-2.53-2.724-3.419-3.165-8.037-1.134-11.875 1.064-2.05 3.154-3.713 5.288-4.736.359-.17.784-.149 1.123.056.339.205.328.565.324.95v7.966h7V2.62c-.003-.383-.015-.74.322-.944a1.193 1.193 0 0 1 1.116-.062z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 21v9.6h13V21",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlSpannerSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var _iconsXlWarningSvg = function _iconsXlWarningSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m16 19.5-.5-11z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.006 24.5a.006.006 0 1 0 0 .013.006.006 0 0 0 0-.013",
    stroke: "currentColor",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

_iconsXlWarningSvg.defaultProps = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { makeIconComponent } from './utils/make-icon-component';
import { reduce, startCase, toLower } from 'lodash';

function getIconName(path) {
  var pathSplit = path.split('/'); // Find the name of the svg from the file, remove the
  // extension, convert to start case and then replace
  // spaces within the string globally

  var iconName = startCase(toLower(pathSplit[pathSplit.length - 1].replace('.svg', ''))).replace(/ /g, '');
  return iconName;
}

function getIconSize(path) {
  var pathSplit = path.split('/'); // If the folders are in the right structure
  // then the size will just be the folder name
  // of the icons parent folder

  return pathSplit[pathSplit.length - 2];
}

export function createIcons() {
  // Getting an error when using a dynamic import path
  // TODO: Revisit this
  var icons = {
    "../icons/l/activity.svg": _iconsLActivitySvg,
    "../icons/l/add.svg": _iconsLAddSvg,
    "../icons/l/app-switcher.svg": _iconsLAppSwitcherSvg,
    "../icons/l/area.svg": _iconsLAreaSvg,
    "../icons/l/arrow-down-circle.svg": _iconsLArrowDownCircleSvg,
    "../icons/l/arrow-left-circle.svg": _iconsLArrowLeftCircleSvg,
    "../icons/l/arrow-right-circle.svg": _iconsLArrowRightCircleSvg,
    "../icons/l/arrow-up-circle.svg": _iconsLArrowUpCircleSvg,
    "../icons/l/bath.svg": _iconsLBathSvg,
    "../icons/l/bed.svg": _iconsLBedSvg,
    "../icons/l/bell.svg": _iconsLBellSvg,
    "../icons/l/buildings.svg": _iconsLBuildingsSvg,
    "../icons/l/calendar.svg": _iconsLCalendarSvg,
    "../icons/l/car.svg": _iconsLCarSvg,
    "../icons/l/chart-bar.svg": _iconsLChartBarSvg,
    "../icons/l/check-circle.svg": _iconsLCheckCircleSvg,
    "../icons/l/check.svg": _iconsLCheckSvg,
    "../icons/l/chevron-down.svg": _iconsLChevronDownSvg,
    "../icons/l/chevron-left.svg": _iconsLChevronLeftSvg,
    "../icons/l/chevron-right.svg": _iconsLChevronRightSvg,
    "../icons/l/chevron-up.svg": _iconsLChevronUpSvg,
    "../icons/l/clock-back.svg": _iconsLClockBackSvg,
    "../icons/l/clock.svg": _iconsLClockSvg,
    "../icons/l/collapse.svg": _iconsLCollapseSvg,
    "../icons/l/columns.svg": _iconsLColumnsSvg,
    "../icons/l/computer.svg": _iconsLComputerSvg,
    "../icons/l/cross-large.svg": _iconsLCrossLargeSvg,
    "../icons/l/cross-small.svg": _iconsLCrossSmallSvg,
    "../icons/l/dashboard.svg": _iconsLDashboardSvg,
    "../icons/l/delete-cross.svg": _iconsLDeleteCrossSvg,
    "../icons/l/document-legal.svg": _iconsLDocumentLegalSvg,
    "../icons/l/download.svg": _iconsLDownloadSvg,
    "../icons/l/drag-handle.svg": _iconsLDragHandleSvg,
    "../icons/l/edit.svg": _iconsLEditSvg,
    "../icons/l/ellipsis.svg": _iconsLEllipsisSvg,
    "../icons/l/envelope.svg": _iconsLEnvelopeSvg,
    "../icons/l/expand.svg": _iconsLExpandSvg,
    "../icons/l/experiment.svg": _iconsLExperimentSvg,
    "../icons/l/eye-closed.svg": _iconsLEyeClosedSvg,
    "../icons/l/eye-open.svg": _iconsLEyeOpenSvg,
    "../icons/l/file.svg": _iconsLFileSvg,
    "../icons/l/filter.svg": _iconsLFilterSvg,
    "../icons/l/folder-archive.svg": _iconsLFolderArchiveSvg,
    "../icons/l/hamburger.svg": _iconsLHamburgerSvg,
    "../icons/l/heart-filled.svg": _iconsLHeartFilledSvg,
    "../icons/l/heart-outline.svg": _iconsLHeartOutlineSvg,
    "../icons/l/house-search.svg": _iconsLHouseSearchSvg,
    "../icons/l/house.svg": _iconsLHouseSvg,
    "../icons/l/info-circle.svg": _iconsLInfoCircleSvg,
    "../icons/l/invoice.svg": _iconsLInvoiceSvg,
    "../icons/l/kebab.svg": _iconsLKebabSvg,
    "../icons/l/keys.svg": _iconsLKeysSvg,
    "../icons/l/lease-agreement.svg": _iconsLLeaseAgreementSvg,
    "../icons/l/loader.svg": _iconsLLoaderSvg,
    "../icons/l/location-marker.svg": _iconsLLocationMarkerSvg,
    "../icons/l/lock-closed.svg": _iconsLLockClosedSvg,
    "../icons/l/lock-open.svg": _iconsLLockOpenSvg,
    "../icons/l/messages-question.svg": _iconsLMessagesQuestionSvg,
    "../icons/l/mobile.svg": _iconsLMobileSvg,
    "../icons/l/note.svg": _iconsLNoteSvg,
    "../icons/l/open.svg": _iconsLOpenSvg,
    "../icons/l/paper-clip.svg": _iconsLPaperClipSvg,
    "../icons/l/people.svg": _iconsLPeopleSvg,
    "../icons/l/person.svg": _iconsLPersonSvg,
    "../icons/l/pin.svg": _iconsLPinSvg,
    "../icons/l/placeholder.svg": _iconsLPlaceholderSvg,
    "../icons/l/printer.svg": _iconsLPrinterSvg,
    "../icons/l/receipt.svg": _iconsLReceiptSvg,
    "../icons/l/ruler.svg": _iconsLRulerSvg,
    "../icons/l/search.svg": _iconsLSearchSvg,
    "../icons/l/settings-gear.svg": _iconsLSettingsGearSvg,
    "../icons/l/settings.svg": _iconsLSettingsSvg,
    "../icons/l/sol.svg": _iconsLSolSvg,
    "../icons/l/sort.svg": _iconsLSortSvg,
    "../icons/l/spanner.svg": _iconsLSpannerSvg,
    "../icons/l/unpin.svg": _iconsLUnpinSvg,
    "../icons/l/warning-circle.svg": _iconsLWarningCircleSvg,
    "../icons/m/activity.svg": _iconsMActivitySvg,
    "../icons/m/add-subract.svg": _iconsMAddSubractSvg,
    "../icons/m/add.svg": _iconsMAddSvg,
    "../icons/m/app-switcher.svg": _iconsMAppSwitcherSvg,
    "../icons/m/area.svg": _iconsMAreaSvg,
    "../icons/m/arrow-back.svg": _iconsMArrowBackSvg,
    "../icons/m/arrow-down-circle.svg": _iconsMArrowDownCircleSvg,
    "../icons/m/arrow-down-filled.svg": _iconsMArrowDownFilledSvg,
    "../icons/m/arrow-down-outline.svg": _iconsMArrowDownOutlineSvg,
    "../icons/m/arrow-left-circle.svg": _iconsMArrowLeftCircleSvg,
    "../icons/m/arrow-left-filled.svg": _iconsMArrowLeftFilledSvg,
    "../icons/m/arrow-right-circle.svg": _iconsMArrowRightCircleSvg,
    "../icons/m/arrow-up-circle.svg": _iconsMArrowUpCircleSvg,
    "../icons/m/bath.svg": _iconsMBathSvg,
    "../icons/m/bed.svg": _iconsMBedSvg,
    "../icons/m/bell.svg": _iconsMBellSvg,
    "../icons/m/buildings.svg": _iconsMBuildingsSvg,
    "../icons/m/calendar.svg": _iconsMCalendarSvg,
    "../icons/m/car.svg": _iconsMCarSvg,
    "../icons/m/chart-bar.svg": _iconsMChartBarSvg,
    "../icons/m/check-circle.svg": _iconsMCheckCircleSvg,
    "../icons/m/check.svg": _iconsMCheckSvg,
    "../icons/m/chevron-down.svg": _iconsMChevronDownSvg,
    "../icons/m/chevron-left.svg": _iconsMChevronLeftSvg,
    "../icons/m/chevron-right.svg": _iconsMChevronRightSvg,
    "../icons/m/chevron-up.svg": _iconsMChevronUpSvg,
    "../icons/m/circle-filled.svg": _iconsMCircleFilledSvg,
    "../icons/m/circle-outline.svg": _iconsMCircleOutlineSvg,
    "../icons/m/clock-back.svg": _iconsMClockBackSvg,
    "../icons/m/clock.svg": _iconsMClockSvg,
    "../icons/m/collapse.svg": _iconsMCollapseSvg,
    "../icons/m/columns.svg": _iconsMColumnsSvg,
    "../icons/m/comment.svg": _iconsMCommentSvg,
    "../icons/m/computer.svg": _iconsMComputerSvg,
    "../icons/m/cross-large.svg": _iconsMCrossLargeSvg,
    "../icons/m/cross-small.svg": _iconsMCrossSmallSvg,
    "../icons/m/dash.svg": _iconsMDashSvg,
    "../icons/m/dashboard.svg": _iconsMDashboardSvg,
    "../icons/m/delete-cross.svg": _iconsMDeleteCrossSvg,
    "../icons/m/document-legal.svg": _iconsMDocumentLegalSvg,
    "../icons/m/download.svg": _iconsMDownloadSvg,
    "../icons/m/drag-handle.svg": _iconsMDragHandleSvg,
    "../icons/m/edit.svg": _iconsMEditSvg,
    "../icons/m/ellipsis.svg": _iconsMEllipsisSvg,
    "../icons/m/envelope.svg": _iconsMEnvelopeSvg,
    "../icons/m/expand.svg": _iconsMExpandSvg,
    "../icons/m/experiment.svg": _iconsMExperimentSvg,
    "../icons/m/eye-closed.svg": _iconsMEyeClosedSvg,
    "../icons/m/eye-open.svg": _iconsMEyeOpenSvg,
    "../icons/m/file.svg": _iconsMFileSvg,
    "../icons/m/filter.svg": _iconsMFilterSvg,
    "../icons/m/folder-archive.svg": _iconsMFolderArchiveSvg,
    "../icons/m/hamburger.svg": _iconsMHamburgerSvg,
    "../icons/m/heart-filled.svg": _iconsMHeartFilledSvg,
    "../icons/m/heart-outline.svg": _iconsMHeartOutlineSvg,
    "../icons/m/house-search.svg": _iconsMHouseSearchSvg,
    "../icons/m/house.svg": _iconsMHouseSvg,
    "../icons/m/info-circle.svg": _iconsMInfoCircleSvg,
    "../icons/m/invoice.svg": _iconsMInvoiceSvg,
    "../icons/m/kebab.svg": _iconsMKebabSvg,
    "../icons/m/keys.svg": _iconsMKeysSvg,
    "../icons/m/loader-progress.svg": _iconsMLoaderProgressSvg,
    "../icons/m/loader.svg": _iconsMLoaderSvg,
    "../icons/m/location-marker.svg": _iconsMLocationMarkerSvg,
    "../icons/m/lock-closed.svg": _iconsMLockClosedSvg,
    "../icons/m/lock-open.svg": _iconsMLockOpenSvg,
    "../icons/m/messages-question.svg": _iconsMMessagesQuestionSvg,
    "../icons/m/mobile.svg": _iconsMMobileSvg,
    "../icons/m/note.svg": _iconsMNoteSvg,
    "../icons/m/open.svg": _iconsMOpenSvg,
    "../icons/m/paper-clip.svg": _iconsMPaperClipSvg,
    "../icons/m/people.svg": _iconsMPeopleSvg,
    "../icons/m/person.svg": _iconsMPersonSvg,
    "../icons/m/pin.svg": _iconsMPinSvg,
    "../icons/m/placeholder.svg": _iconsMPlaceholderSvg,
    "../icons/m/printer.svg": _iconsMPrinterSvg,
    "../icons/m/receipt.svg": _iconsMReceiptSvg,
    "../icons/m/refresh.svg": _iconsMRefreshSvg,
    "../icons/m/ruler.svg": _iconsMRulerSvg,
    "../icons/m/search.svg": _iconsMSearchSvg,
    "../icons/m/settings-gear.svg": _iconsMSettingsGearSvg,
    "../icons/m/settings.svg": _iconsMSettingsSvg,
    "../icons/m/sol.svg": _iconsMSolSvg,
    "../icons/m/sort.svg": _iconsMSortSvg,
    "../icons/m/spanner.svg": _iconsMSpannerSvg,
    "../icons/m/text-bold.svg": _iconsMTextBoldSvg,
    "../icons/m/text-bulleted-list.svg": _iconsMTextBulletedListSvg,
    "../icons/m/text-italics.svg": _iconsMTextItalicsSvg,
    "../icons/m/text-link.svg": _iconsMTextLinkSvg,
    "../icons/m/text-numbered-list.svg": _iconsMTextNumberedListSvg,
    "../icons/m/unpin.svg": _iconsMUnpinSvg,
    "../icons/m/warning-circle.svg": _iconsMWarningCircleSvg,
    "../icons/m/warning.svg": _iconsMWarningSvg,
    "../icons/s/activity.svg": _iconsSActivitySvg,
    "../icons/s/add.svg": _iconsSAddSvg,
    "../icons/s/area.svg": _iconsSAreaSvg,
    "../icons/s/arrow-back.svg": _iconsSArrowBackSvg,
    "../icons/s/arrow-down-circle.svg": _iconsSArrowDownCircleSvg,
    "../icons/s/arrow-down.svg": _iconsSArrowDownSvg,
    "../icons/s/arrow-left-circle.svg": _iconsSArrowLeftCircleSvg,
    "../icons/s/arrow-left.svg": _iconsSArrowLeftSvg,
    "../icons/s/arrow-right-circle.svg": _iconsSArrowRightCircleSvg,
    "../icons/s/arrow-right.svg": _iconsSArrowRightSvg,
    "../icons/s/arrow-up-circle.svg": _iconsSArrowUpCircleSvg,
    "../icons/s/arrow-up.svg": _iconsSArrowUpSvg,
    "../icons/s/buildings.svg": _iconsSBuildingsSvg,
    "../icons/s/check.svg": _iconsSCheckSvg,
    "../icons/s/chevron-down.svg": _iconsSChevronDownSvg,
    "../icons/s/chevron-left.svg": _iconsSChevronLeftSvg,
    "../icons/s/chevron-right.svg": _iconsSChevronRightSvg,
    "../icons/s/chevron-up.svg": _iconsSChevronUpSvg,
    "../icons/s/circle-filled.svg": _iconsSCircleFilledSvg,
    "../icons/s/circle-outline.svg": _iconsSCircleOutlineSvg,
    "../icons/s/clock-back.svg": _iconsSClockBackSvg,
    "../icons/s/clock.svg": _iconsSClockSvg,
    "../icons/s/collapse.svg": _iconsSCollapseSvg,
    "../icons/s/computer.svg": _iconsSComputerSvg,
    "../icons/s/cross-small.svg": _iconsSCrossSmallSvg,
    "../icons/s/dash.svg": _iconsSDashSvg,
    "../icons/s/delete-cross.svg": _iconsSDeleteCrossSvg,
    "../icons/s/document-legal.svg": _iconsSDocumentLegalSvg,
    "../icons/s/download.svg": _iconsSDownloadSvg,
    "../icons/s/drag-handle.svg": _iconsSDragHandleSvg,
    "../icons/s/edit.svg": _iconsSEditSvg,
    "../icons/s/ellipsis.svg": _iconsSEllipsisSvg,
    "../icons/s/envelope.svg": _iconsSEnvelopeSvg,
    "../icons/s/expand.svg": _iconsSExpandSvg,
    "../icons/s/file.svg": _iconsSFileSvg,
    "../icons/s/hamburger.svg": _iconsSHamburgerSvg,
    "../icons/s/heart-filled.svg": _iconsSHeartFilledSvg,
    "../icons/s/heart-outline.svg": _iconsSHeartOutlineSvg,
    "../icons/s/house-search.svg": _iconsSHouseSearchSvg,
    "../icons/s/house.svg": _iconsSHouseSvg,
    "../icons/s/info-circle.svg": _iconsSInfoCircleSvg,
    "../icons/s/invoice.svg": _iconsSInvoiceSvg,
    "../icons/s/kebab.svg": _iconsSKebabSvg,
    "../icons/s/keys.svg": _iconsSKeysSvg,
    "../icons/s/loader.svg": _iconsSLoaderSvg,
    "../icons/s/location-marker.svg": _iconsSLocationMarkerSvg,
    "../icons/s/mobile.svg": _iconsSMobileSvg,
    "../icons/s/note.svg": _iconsSNoteSvg,
    "../icons/s/open.svg": _iconsSOpenSvg,
    "../icons/s/paper-clip.svg": _iconsSPaperClipSvg,
    "../icons/s/person.svg": _iconsSPersonSvg,
    "../icons/s/pin.svg": _iconsSPinSvg,
    "../icons/s/placeholder.svg": _iconsSPlaceholderSvg,
    "../icons/s/printer.svg": _iconsSPrinterSvg,
    "../icons/s/receipt.svg": _iconsSReceiptSvg,
    "../icons/s/settings.svg": _iconsSSettingsSvg,
    "../icons/s/spanner.svg": _iconsSSpannerSvg,
    "../icons/s/warning-circle.svg": _iconsSWarningCircleSvg,
    "../icons/xl/activity.svg": _iconsXlActivitySvg,
    "../icons/xl/area.svg": _iconsXlAreaSvg,
    "../icons/xl/arrow-down-circle.svg": _iconsXlArrowDownCircleSvg,
    "../icons/xl/arrow-left-circle.svg": _iconsXlArrowLeftCircleSvg,
    "../icons/xl/arrow-right-circle.svg": _iconsXlArrowRightCircleSvg,
    "../icons/xl/arrow-up-circle.svg": _iconsXlArrowUpCircleSvg,
    "../icons/xl/buildings.svg": _iconsXlBuildingsSvg,
    "../icons/xl/calendar.svg": _iconsXlCalendarSvg,
    "../icons/xl/check.svg": _iconsXlCheckSvg,
    "../icons/xl/clock.svg": _iconsXlClockSvg,
    "../icons/xl/computer.svg": _iconsXlComputerSvg,
    "../icons/xl/dashboard.svg": _iconsXlDashboardSvg,
    "../icons/xl/document-legal.svg": _iconsXlDocumentLegalSvg,
    "../icons/xl/envelope.svg": _iconsXlEnvelopeSvg,
    "../icons/xl/file.svg": _iconsXlFileSvg,
    "../icons/xl/hamburger.svg": _iconsXlHamburgerSvg,
    "../icons/xl/heart-filled.svg": _iconsXlHeartFilledSvg,
    "../icons/xl/heart-outline.svg": _iconsXlHeartOutlineSvg,
    "../icons/xl/house-search.svg": _iconsXlHouseSearchSvg,
    "../icons/xl/house.svg": _iconsXlHouseSvg,
    "../icons/xl/invoice.svg": _iconsXlInvoiceSvg,
    "../icons/xl/keys.svg": _iconsXlKeysSvg,
    "../icons/xl/location-marker.svg": _iconsXlLocationMarkerSvg,
    "../icons/xl/mobile.svg": _iconsXlMobileSvg,
    "../icons/xl/note.svg": _iconsXlNoteSvg,
    "../icons/xl/person.svg": _iconsXlPersonSvg,
    "../icons/xl/placeholder.svg": _iconsXlPlaceholderSvg,
    "../icons/xl/printer.svg": _iconsXlPrinterSvg,
    "../icons/xl/receipt.svg": _iconsXlReceiptSvg,
    "../icons/xl/settings.svg": _iconsXlSettingsSvg,
    "../icons/xl/spanner.svg": _iconsXlSpannerSvg,
    "../icons/xl/warning.svg": _iconsXlWarningSvg
  };
  var sortedIcons = reduce(icons, function (acc, icon, path) {
    var size = getIconSize(path);
    var iconName = getIconName(path);
    acc[iconName] = _objectSpread(_objectSpread({}, acc[iconName]), {}, _defineProperty({}, size, icon));
    return acc;
  }, {});
  return reduce(sortedIcons, function (acc, icons, name) {
    acc[name] = makeIconComponent(icons, name);
    return acc;
  }, {});
}
var icons = createIcons();
export default icons;